(function (app) {
  $(document).ready(function () {

    String.prototype.escapeSpecialChars = function () {
      return this.replace(/\\n/g, "\\n")
        .replace(/\\'/g, "\\'")
        .replace(/\\"/g, '\\"')
        .replace(/\\&/g, "\\&")
        .replace(/\\r/g, "\\r")
        .replace(/\\t/g, "\\t")
        .replace(/\\b/g, "\\b")
        .replace(/\\f/g, "\\f");
    };

    app.getUnsavedCampaign = function () {
      // Fetch from localStorage
      var key = "Post__campaign";
      var campaign = $.localStorage.get(key);

      if (typeof campaign != 'undefined' && !_.isEmpty(campaign)) {
        return campaign;
      }
      return false;
    };

    app.removeUnsavedCampaign = function () {
      var key = "Post__campaign";
      $.localStorage.remove(key);
    };

    app.Campaign = function () {

      var _this = this,
        nameSpace = 'Campaign',
        socialNameSpace = 'CampaignSocial',
        context = '.page__campaign-view--container',
        $context = $(context),
        animation = 'fadeIn',
        dataTable = '.table__posts-list',
        templates = {
          'postRow': app.templates["Post__campaign____row-post"],
          'facebookPost': app.templates["Post__campaign____post-facebook"],
          'linkedInPost': app.templates["Post__campaign____post-linkedin"],
          'twitterPost': app.templates["Post__campaign____post-twitter"],
          'googlePlusPost': app.templates["Post__campaign____post-google-plus"],
          'facebookAccountRow': app.templates["Post__campaign____row-facebook-accounts"],
          'imageRow': app.templates["Post__campaign____row-image"],
          'postEditMenu': app.templates["Post__campaign____edit-post-menu"],
          'fontsDropdown': app.templates["Image__editor____fonts-dropdown"],
          'noPosts': app.templates["Post__campaign____no-posts"],
          'allScheduled': app.templates["Post__campaign____all-scheduled"],
        },
        socialCharLimits = {
          'twitter': 280,
          'linkedIn': 700,
          'facebook': 63206
        },
        facebookConnected = !$(':input[name="socialNetwork[]"][value=facebook]').attr('data-disconnected'),
        postBody = '.table__posts-body',
        favoriteBody = '.table__posts-favorite-body',
        $postBody = $(postBody, $context),
        $facebookPostBody = $('.facebook__posts-body', $context),
        $linkedInPostBody = $('.linkedIn__posts-body', $context),
        $twitterPostBody = $('.twitter__posts-body', $context),
        $googlePlusPostBody = $('.googlePlus__posts-body', $context),
        $favoriteBody = $(favoriteBody),

        $dateTimePickerModal = $('#datetime-picker-modal')
        ;

      var dateTimePickerOptions = {
        inline: true,
        locale: 'en',
        keepOpen: true,
        ignoreReadonly: true,
        sideBySide: true,
        minDate: moment(),
        icons: {
          time: 'fas fa-clock',
          date: 'fas fa-calendar',
          up: 'fas fa-chevron-up',
          down: 'fas fa-chevron-down',
          previous: 'fas fa-chevron-left',
          next: 'fas fa-chevron-right',
          today: 'glyphicon glyphicon-screenshot',
          clear: 'glyphicon glyphicon-trash'
        },
      };
      /**
       * Return sessionStorage
       */
      _this.sessionStorage = function () {
        return $.sessionStorage;
      }();

      _this.storage = function () {
        return $.localStorage;
      }();

      _this.pageParams = function () {
        var key = nameSpace + '__campaign';
        return {
          set: function (params) {
            var pageParams = $.extend({}, _this.sessionStorage.get(key), params);
            _this.sessionStorage.set(key, pageParams);
            if (_this.getCampaignId() == false) {
              pageParams = $.extend({}, _this.storage.get(key), params);
              _this.storage.set(key, pageParams);
            }
          },
          get: function () {
            return _this.sessionStorage.get(key);
          },
          reset: function () {
            _this.storage.remove(key);
          },
          resetSession: function () {
            _this.sessionStorage.remove(key);
          }
        }
      };

      /**
       * Validate Campaign Name
       * @returns {boolean}
       */
      _this.validateCampaignName = function () {
        var validated = true;
        var $form = $('form[name=questionnaire__form]');

        var $campaign = $(':input[name=campaignName]', $form);
        var campaignName = $.trim($campaign.val());

        if (campaignName == '') {
          validated = false;
        }

        if (validated) {
          $campaign.removeClass('is-invalid');
        } else {
          $campaign.addClass('is-invalid');
        }

        return validated;
      };

      /**
       * Validate Questionnaire Settings section
       * @returns {boolean}
       */
      _this.validateQuestionnaireSettings = function () {
        var validated = true;
        var $section = $('.section__settings');

        if ($(':input[name=startDate]', $section).val() == '') {
          validated = false;
        }

        if (validated) {
          $section.closest('.card').removeClass('not-validated');
          _this.validateCampaignName();
        } else {
          $section.closest('.card').addClass('not-validated');
        }
        return validated;
      };

      /**
       * Validate Questionnaire Information section
       * @returns {boolean}
       */
      _this.validateQuestionnaireInformation = function () {
        var formElements = [];
        var radios = [];
        var formElementsName = [];
        var $sectionInformation = $('.section__information');

        $(':input:not(button)', $sectionInformation).each(function () {
          if (typeof $(this).attr('data-validate') == 'undefined' || $(this).attr('data-validate') == 'yes') {
            formElements.push({name: $(this).attr('name'), type: $(this).attr('type')});
            formElementsName.push($(this).attr('name'));
          }
        });

        formElementsName = _.uniq(formElementsName);

        $.each(formElementsName, function (stepIndex, name) {
          var $el = $(":input[name='" + name + "']", $('.section__information')),
            validated = true, value;
          if ($el.length) {
            $el.removeClass('is-invalid');
            var type = $el[0].type || $el[0].tagName.toLowerCase();
            switch (type) {
              case 'select-multiple' :
                value = $.trim($el.val());
                if ((value == '' || typeof value == 'undefined')) {
                  validated = false;
                }
                break;
              case 'select-one' :
                value = $.trim($el.val());
                var $eventSwitch = $el.closest('.event-switch');
                if ($eventSwitch.length == 0 && (value == '' || typeof value == 'undefined')) {
                  validated = false;
                } else if (($eventSwitch.length && $eventSwitch.is(":visible"))  && (value == '' || typeof value == 'undefined')) {
                  validated = false;
                }
                break;
              case 'radio' :
                if (!$el.is(":checked")) {
                  validated = false;
                }
                break;

              case 'number' :
              case 'text':
              case 'textarea':
                value = $.trim($el.val());
                var $inputRadio = $el.closest('.form-row').find('.radio-with-form-control');
                var inputRadio = $inputRadio.length;

                if (!inputRadio && value == '') {
                  validated = false;
                }

                if (inputRadio) {
                  name = $inputRadio.find('input[type=radio]').attr('name');
                  $el = $(":input[name='" + name + "']");
                  var $elInput = $(":input[name='" + name + "']:checked").closest('.form-row').find('input:not([type=radio])');
                  value = $elInput.length ? $elInput.val() : '';
                  if ($el.is(":checked") && $elInput.length && value == '') {
                    validated = false;
                  }
                }

                var $customSwitch = $el.closest('.custom-switch__wrapper').find('input');
                // Question outside of event switch
                if (value == '' && $el.closest('.event-switch').length == 0) {
                  validated = false;
                } // Question inside switch
                else if ($customSwitch.is(':checked') && value == '') {
                  validated = false;
                } // Question without event switch
                else if ($customSwitch.length) {
                  validated = true;
                }

                // Other Question validation
                if (value == '' && $el.closest('[data-option-other]').length && !$el.closest('[data-option-other]').is(":visible")) {
                  validated = true;
                }
                break;
            }


            if (validated == false) {
              $el.addClass('is-invalid');
            }
          }
        });

        var validated = true;
        if ($(':input:not(button).is-invalid', $sectionInformation).length > 0) {
          validated = false;
        }

        // Valiate question[13]
        var $linkEl = $(':input[name="question[13]"]', $sectionInformation);
        var link = $.trim($linkEl.val());

        if (link != '' && !((/^http:\/\//.test(link)) || (/^https:\/\//.test(link)))) {
          link = "http://" + link;
          $linkEl.val(link);
        }

        if (validated) {
          $('.section__information').closest('.card').removeClass('not-validated');
          if (_this.validateQuestionnaireSettings()) {
            $('.questionnaire__complete', $context).addClass('active');
            _this.validateCampaignName();
          }
        } else {
          $('.questionnaire__complete', $context).removeClass('active');
          $('.section__information').closest('.card').addClass('not-validated');
        }
        return validated;
      };

      /**
       * Event for social category change
       * @param value
       * @param cleanOthers
       */
      _this.socialCategoryChange = function (value, cleanOthers) {
        if (cleanOthers) {
          $(".field__tag--social_sub_categories--wrapper")
            .find('select').each(function () {
              $(this).val('').trigger('change');
            }).end()
            .hide();
        } else {
          $(".field__tag--social_sub_categories--wrapper").hide().removeClass('animated fadeIn slideInRight');
        }

        $('.page__title > [data-category]').text(value);
        $(".field__tag--social_sub_categories--wrapper[data-category='" + value + "']").show().addClass('animated ' + animation);

        setTimeout(function () {
          $(".field__tag--social_sub_categories--wrapper[data-category='" + value + "']").removeClass('animated ' + animation);
        }, 1000);

        $.scrollTo($('.step__1-1'), {
          duration: 300, onAfter: function () {
          }
        });
      };

      /**
       * Get Hash
       * @returns {0,1,2,3}
       */
      _this.getHash = function () {
        var hash = window.location.hash;
        if (_.isEmpty(hash)) {
          hash = '#tab_1';
        }
        return $.trim(hash.replace('#', ''));
      };

      _this.campaignLoader = function () {
        return {
          show: function (build) {
            build = build || false;
            var $campaignLoaderContainer = $('.campaign-loader-container');
            if (build == true) {
              $campaignLoaderContainer.find('.campaign-edit').addClass('d-none').end()
                .find('.campaign-build').removeClass('d-none');
            } else {
              $campaignLoaderContainer.find('.campaign-build').addClass('d-none').end()
                .find('.campaign-edit').removeClass('d-none');
            }
            $campaignLoaderContainer.show().removeClass('d-none');
          },
          hide: function () {
            var $campaignLoaderContainer = $('.campaign-loader-container');
            $campaignLoaderContainer.addClass('animated fadeOut');
            setTimeout(function () {
              $campaignLoaderContainer.removeClass('animated fadeOut').addClass('d-none');
            }, 2000);
          }
        }
      }();

      _this.setHash = function (hash) {
        window.location.hash = hash;
      };

      /**
       * Navigate to passed hash
       * @param hash
       */
      _this.navigate = function (hash) {
        if (hash == 'tab_0') {
          $('.steps--indicators').addClass('invisible');
        } else {
          var stepHash = hash.split('-')[0];
          $('.steps--indicators').removeClass('invisible').find('a > div').removeClass('active').end()
            .find('a[data-step=' + stepHash + ']  > div').addClass('active').end()
        }

        $(context + ' .steps__wrapper').hide().removeClass('animated fadeIn slideInRight');
        $(context + ' .steps__wrapper[data-step="' + hash + '"]').show().addClass('animated ' + animation);

        if (hash == 'tab_1-1' && app.documentWidth > 768) {
          $(context + ' .steps__wrapper[data-step=' + 'tab_1' + ']').show();
        }

        if (hash == 'tab_3') {
          _this.getPosts(_this.getPostData());
        }

        setTimeout(function () {
          $(context + ' .steps__wrapper[data-step="' + hash + '"]').removeClass('animated ' + animation);
        }, 1000);
      };

      _this.findOptionByValue = function ($select, value) {
        var $option = false;
        $select.find('option').each(function () {
          if ($(this).val() == value) {
            $option = $(this);
          }
        });

        return $option;
      };

      /**
       * Set default keywords for image
       * @param name
       * @param text
       * @param id
       * @param locked
       */
      _this.setDefaultImageKeywords = function (name, text, id, locked) {
        var data = {
          'text': text,
          'id': id
        };

        var $imageKeywords = $('.select2-image-keywords');
        var find = _this.findOptionByValue($imageKeywords, text);

        if (find == false) {
          var newOption = new Option(data.text, data.id, true, true);
          if (locked) {
            $(newOption).attr('locked', 'locked')
          }
          $imageKeywords.append(newOption).trigger('change');
        }


      };

      /**
       * Set default keywords for hashtags
       * @param name
       * @param text
       * @param id
       */
      _this.setDefaultHashtagKeywords = function (name, text, id) {
        var data = {
          'text': text,
          'id': id
        };

        var $keywords = $('.select2-hashtags-keywords');
        var find = _this.findOptionByValue($keywords, text);

        if (find) {
          find.remove();
        }

        var newOption = new Option(data.text, data.id, true, true);
        $keywords.append(newOption).trigger('change');

      };

      /**
       * Window Resize events
       */
      _this.resize = function () {
        var hash = _this.getHash();

        if (hash == 'tab_tab_1-1') {
          if (app.documentWidth > 768) {
            $(context + ' .steps__wrapper[data-step=' + 'tab_1' + ']').show();
          } else {
            $(context + ' .steps__wrapper[data-step=' + 'tab_1' + ']').hide();
          }
        }

        if (app.documentWidth > 768) {
          animation = 'fadeIn';
        } else {
          animation = 'slideInRight';
        }

      };

      /**
       * Render a post row
       * @param template
       * @param row
       * @param $postBody
       * @returns {jQuery|HTMLElement}
       */
      _this.renderPostRow = function (template, row, $postBody, $prePend) {
        $prePend = $prePend || false;
        var postRow = _.template(templates[template]);
        var $postRow = $(
          postRow(
            $.extend(row, {
              'text': row.text.trim(),
              'image': _.isUndefined(row.image) ? null : row.image,
              'postDateFormatter': moment(row.dateScheduled.date).format('DD MMMM YYYY @ h:mm a'),
              'postDate': moment(row.dateScheduled.date).format('MM/DD/YY h:mm a'),
              'dateScheduled': moment(row.dateScheduled.date).format('MM/DD/YYYY @ h:mm a'),
              'dataDate': moment(row.dateScheduled.date).format('YYYY-MM-DD HH:mm:ss'),
            })
          )
        );
        if ($prePend) {
          $postRow.prependTo($postBody);
        } else {
          $postRow.appendTo($postBody);
        }
        return $postRow;
      };

      _this.initDateTimePicker = function (el, defaultDate) {
        if (el.hasClass('initialized')) return;
        el.datetimepicker({
          locale: 'en',
          defaultDate: defaultDate,
          keepOpen: true,
          ignoreReadonly: true,
          sideBySide: true,
          minDate: moment(),
          format: 'MM/DD/YYYY @ h:mm a',
          icons: {
            time: 'fas fa-clock',
            date: 'fas fa-calendar',
            up: 'fas fa-chevron-up',
            down: 'fas fa-chevron-down',
            previous: 'fas fa-chevron-left',
            next: 'fas fa-chevron-right',
            today: 'glyphicon glyphicon-screenshot',
            clear: 'glyphicon glyphicon-trash'
          },
          widgetPositioning: {
            horizontal: 'left'
          }
        }).on('dp.show', function () {
          $('.builder__wrapper').addClass('calendar-open');
          $('.post__action-wrapper').addClass('calendar-open');
        }).on('dp.hide', function (e) {
          $(e.target).find('input').attr('data-value', moment(app.localToUtc(e.date)).unix());
          var dataId = $(e.target).closest('[data-row]').attr('data-row');
          if (typeof dataId != 'undefined' && dataId != '') {
            _this.postActions().update(dataId, {'dateScheduled': moment(app.localToUtc(e.date)).unix()});
          }
          $('.builder__wrapper').removeClass('calendar-open');
          $('.post__action-wrapper').removeClass('calendar-open');
          if ($(e.target).closest('.section__information').length) {
            _this.validateQuestionnaireInformation();
          }
        });
        el.addClass('initialized');
      };

      _this.initPagination = function (el, currentPostId) {
        currentPostId = typeof currentPostId == 'undefined' ? false : currentPostId;
        var totalRecords = el.find('[data-row]').length;
        var pageLimit = 10;
        var $paginator = el.parent().find('.pagination');
        $paginator.twbsPagination('destroy');
        var totalPages = Math.ceil(totalRecords / pageLimit);
        var $activeSlide = $postBody.find('.post-row').eq(0);
        if (currentPostId) {
          $activeSlide = $postBody.find('.post-row[data-row=' + currentPostId + ']');
        }
        var currentPage = Math.floor($activeSlide.prevAll().length / pageLimit) + 1;

        $('[data-post-count]').text(totalRecords).removeClass('m-progress');
        $paginator.twbsPagination({
          totalPages: totalPages,
          visiblePages: 1,
          startPage: currentPage,
          prev: '<i class="fas fa-chevron-circle-left">  </i> Previous',
          next: '<i class="fas fa-chevron-circle-right"> </i> Next',
          onPageClick: function (event, page) {
            $('.page-counter', el).text('Page ' + page + ' of ' + totalPages).attr('data-page', page);

            var $dataRow = el.find('[data-row]');
            if (page > currentPage) {
              var nextOffset = ((page - 1) * pageLimit) - 1;
              $dataRow.eq(nextOffset).nextAll().slice(0, pageLimit).removeClass('hide').addClass('animated slideInRight');
              $dataRow.eq(nextOffset + 1).prevAll().addClass('hide').removeClass('animated slideInRight');
            } else if (page < currentPage) {
              var prevOffset = ((page) * pageLimit);
              $dataRow.eq(prevOffset).prevAll().slice(0, pageLimit).removeClass('hide').addClass('animated slideInLeft');
              $dataRow.eq(prevOffset - 1).nextAll().addClass('hide').removeClass('animated slideInLeft');
            } else {
              var currentOffset = ((page - 1) * pageLimit);
              $dataRow.eq(currentOffset).removeClass('hide').addClass('animated slideInLeft');
              $dataRow.eq(currentOffset).nextAll().slice(0, pageLimit - 1).removeClass('hide').addClass('animated slideInLeft');
            }

            currentPage = page;
          }
        });
      };

      _this.getPostData = function () {
        var postData = _this.pageParams().get();
        var posts = {};
        var stepCounter = 1;
        _.each(postData.posts, function (post, index) {
          post.timeIndex = moment(post.dateScheduled.date).unix();
        });
        postData.posts = _.sortBy(postData.posts, 'timeIndex');

        _.each(postData.posts, function (post, index) {
          post.index = stepCounter++;
          posts[post.id + "_index"] = post;
        });

        postData.posts = posts;
        return postData;
      };

      app.getPostData = _this.getPostData;

      _this.updatePost = function (id, data) {
        var postData = _this.getPostData();
        var post = postData.posts[id + "_index"];
        postData.posts[id] = $.extend({}, post, data);
        _this.pageParams().set(postData);
        return postData;
      };

      _this.deletePost = function (id) {
        var postData = _this.getPostData();
        delete postData.posts[id + "_index"];
        _this.pageParams().set(postData);
        return postData;
      };

      _this.getPost = function (id) {
        var postData = _this.getPostData();
        var row = postData.posts[id + "_index"];
        row.username = postData.user;
        row.uniqueId = app.generateId();
        return row;
      };

      app.getPost = _this.getPost;

      // To update Table view
      _this.updateList = function (response, currentPostId) {
        // Clean up all existing data in dom
        $postBody.html('');
        $facebookPostBody.html('');
        $linkedInPostBody.html('');
        $twitterPostBody.html('');
        $googlePlusPostBody.html('');
        $favoriteBody.html('');
        $(dataTable).removeClass('loading-state');
        var responsePosts = response.posts;

        if (typeof responsePosts != 'undefined' && ( _.size(responsePosts) )) {
          $('.post__action-wrapper').show();
          $('.post-slide--actions').show();
          _.each(response.posts, function (row, stepIndex) {
            row.uniqueId = app.generateId();
            row.username = response.user;

            var postRow = _this.renderPostRow('postRow', row, $postBody);
            app.lazyLoadImage(_this.initDateTimePicker(postRow.find('.btn-calendar'), row.postDate));

            if (row.favorite) {
              var $favorite = postRow.find('.btn-favorite');
              $favorite.attr('data-action', 'unfavorite');
              _this.markAsFavorite($favorite, false);
            }
          });
          _this.indexPosts($postBody);
          _this.initPagination($postBody.parent(), currentPostId);
          var $activeSlide = $postBody.find('.post-row').eq(0);
          if (currentPostId) {
            $activeSlide = $postBody.find('.post-row[data-row=' + currentPostId + ']');
          }
          _this.slide($activeSlide);
        } else {
          $('[data-post-count]').text(0).removeClass('m-progress');
          $('.page__no--records').show();
          $('.post__action-wrapper').hide();
          $('.post-slide--actions').hide();
          var $socialPostBody = _this.getActivePostBody();
          $socialPostBody = $socialPostBody[1];
          if (response.postsScheduled === true) {
            var allScheduled = _.template(templates['allScheduled']);
            var $allScheduled = $(
              allScheduled({
                'id': _this.getCampaignId(),
                'custom': typeof response.config['custom'] == 'undefined' ? false : response.config['custom']
              })
            );

            $socialPostBody.append($allScheduled);
          } else {
            var noPosts = _.template(templates['noPosts']);
            var $noPosts = $(
              noPosts({})
            );

            $socialPostBody.append($noPosts);
          }

        }

      };

      _this.indexPosts = function (el) {
        var rows = el.find('[data-row]');
        var length = rows.length;

        $.each(rows, function (stepIndex) {
          $(this).attr('data-index', stepIndex);
        });

      };

      _this.getPosts = function (response, currentPostId) {
        currentPostId = typeof currentPostId == 'undefined' ? false : currentPostId;
        $(dataTable).addClass('loading-state');
        $('.page__no--records').hide();
        _this.updateList(response, currentPostId);
      };

      _this.getActivePostPreviewTab = function () {
        return $('.post_preview__section .nav-link.active').attr('href');
      };

      _this.getActivePostBody = function () {
        switch (_this.getActivePostPreviewTab()) {
          case '#preview__facebook' :
            return ['facebookPost', $facebookPostBody];
            break;
          case '#preview__linkedIn' :
            return ['linkedInPost', $linkedInPostBody];
            break;
          case '#preview__twitter' :
            return ['twitterPost', $twitterPostBody];
            break;
          case '#preview__googlePlus' :
            return ['googlePlusPost', $googlePlusPostBody];
            break;
        }
      };

      _this.getActiveLibraryTab = function () {
        return $('.library__section .nav-link.active').attr('data-target');
      };

      _this.truncate = function (s, n) {
        var cut = s.indexOf(' ', n);
        if (cut == -1) return s;
        return s.substring(0, cut)
      };

      _this.postActions = function () {
        return {
          image: function () {
            return {
              get: function (imageId) {
                var query = $.Deferred();
                var appTransport = app.transport();

                appTransport
                  .setEvent('onSuccess', function (response) {
                    return query.resolve(response);
                  })
                  .setEvent('onError', function (error) {
                    return query.reject(error);
                  })
                  .setEvent('onComplete', function () {

                  })
                ;
                appTransport.get('/api/image/' + imageId);
                return query.promise();
              },
            }
          },
          facebook: function () {
            return {
              get: function () {
                $(dataTable).addClass('loading-state');
                $('.page__no--records').hide();

                var query = $.Deferred();
                var appTransport = app.transport();

                appTransport
                  .setEvent('onSuccess', function (response) {
                    // Clean up all existing data in dom
                    var $tableBodies = $('.table__facebook-accounts-body', $(context).context);

                    $(dataTable).removeClass('loading-state');

                    $.each($tableBodies, function (stepIndex, tableBody) {
                      var $tableBody = $(tableBody);
                      $tableBody.html('');
                      if (typeof response.accounts != 'undefined' && response.accounts.length) {
                        _.each(response.accounts, function (row) {
                          var dataRow = _.template(templates.facebookAccountRow);
                          var $dataRow = $(
                            dataRow(
                              $.extend(row, {
                                'random': _.random(0, 9999999)
                              })
                            )
                          );
                          $dataRow.appendTo($tableBody);
                        });
                      }
                    });

                    return query.resolve(response);
                  })
                  .setEvent('onError', function (error) {
                    app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                    return query.reject(error);
                  })
                  .setEvent('onComplete', function () {

                  })
                ;
                appTransport.get('/api/social/facebook/active-accounts');
                return query.promise();
              },
              delete: function (accountId) {
                var query = $.Deferred();
                var appTransport = app.transport();
                appTransport
                  .setEvent('onSuccess', function (response) {
                    return query.resolve(response);
                  })
                  .setEvent('onError', function (error) {
                    app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                  })
                  .setEvent('onComplete', function () {

                  })
                ;
                appTransport.delete('/api/social/facebook/accounts/' + accountId);
                return query.promise();
              },
              update: function (accountId, requestData) {
                var query = $.Deferred();
                var appTransport = app.transport();
                appTransport
                  .setEvent('onSuccess', function (response) {
                    return query.resolve(response);
                  })
                  .setEvent('onError', function (error) {
                    app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                  })
                  .setEvent('onComplete', function () {

                  })
                ;
                appTransport.put('/api/social/facebook/accounts/' + accountId, requestData);
                return query.promise();
              }
            }
          },
          delete: function (postId) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.delete('/api/post/post/' + postId);
            return query.promise();
          },
          update: function (postId, requestData) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                if (_this.getHash() == 'tab_3') {
                  _this.pageParams().set({'posts': response.posts});
                  _this.getPosts(_this.getPostData(), postId);
                  app.flashMessenger('success', response.message);
                }
                if (_this.getHash() == 'tab_4') {
                  appCampaignStep4.getList();
                }
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.put('/api/post/post/' + postId, requestData);
            return query.promise();
          },
          create: function (requestData) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                if (_this.getHash() == 'tab_3') {
                  _this.pageParams().set({'posts': response.posts});
                  _this.getPosts(_this.getPostData(), response.id);
                  app.flashMessenger('success', response.message);
                }
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.post('/api/post/post', requestData);
            return query.promise();
          },
          spellcheck: function (postId, requestData) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.post('/api/post/spellcheck', requestData);
            return query.promise();
          },
          favorite: function (postId) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                _this.pageParams().set({'posts': response.posts});
                _this.getPosts(_this.getPostData(), postId);
                app.flashMessenger('success', response.message);
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.put('/api/post/favorite/' + postId);
            return query.promise();
          },
          unfavorite: function (postId) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                _this.pageParams().set({'posts': response.posts});
                _this.getPosts(_this.getPostData(), postId);
                app.flashMessenger('success', response.message);
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.delete('/api/post/favorite/' + postId);
            return query.promise();
          },
          shareToFacebook: function (url) {
            $('<a> </a>').attr({'target': '_blank', href: url, 'id': 'facebook-share-link'}).appendTo($(document.body));
            $('#facebook-share-link')[0].click();

            setTimeout(function () {
              $('#facebook-share-link').remove();
            }, 1000);
          },
          schedule: function () {
            var query = $.Deferred();

            var $form = $('form[name=scheduler__form]');
            var requestData = $form.serializeObject();

            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                if ($(':input[name=dateScheduled]', $form).is(':disabled')) {
                  $('.post-row', $(dataTable)).attr('data-post-reminder', false);
                  if (typeof response.url != 'undefined') {
                    var $button = $('button[data-reminder="post-now"]', $form);
                    $button.button('reset');
                    $button.button('loading-left');
                    setTimeout(function () {
                      $button.button('reset');
                      _this.postActions().shareToFacebook(response.url);

                      return query.resolve(response);
                    }, 15000);

                    var secs = 15;
                    var x = setInterval(function () {
                      --secs;

                      $button.text('This process will take ' + secs + ' secs');
                      if (secs <= 0) {
                        clearInterval(x);
                        $button.button('reset');
                      }
                    }, 1000);

                  } else {
                    var $button = $('button[data-reminder="reminder"]', $form);
                    $button.button('reset');
                    app.flashMessenger('success', response.message);
                    return query.resolve(response);
                  }
                } else {
                  app.flashMessenger('success', response.message);
                  return query.resolve(response);
                }

              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                return query.reject(error);
              })
              .setEvent('onComplete', function () {

              })
            ;

            if (typeof requestData.socialNetwork == 'undefined') {
              app.flashMessenger('error', 'Please select social networks');
              return query.reject();
            } else {
              if (requestData.socialNetwork.indexOf('facebook') >= 0
                && typeof requestData.socialProvider == 'undefined' && $(':input[name=dateReminder]', $form).is(':disabled')) {
                app.flashMessenger('error', 'Please select pages to post for facebook ');
                return query.reject();
              }
            }

            var connectionError = false;
            _.each(requestData.socialNetwork, function (socialNetwork) {
              var $field = $(':input[name="socialNetwork[]"][value="' + socialNetwork + '"]', $form);
              if (typeof $field.attr('data-disconnected') != 'undefined') {
                $field.prop('checked', false);
                if ($(':input[name=dateReminder]', $form).is(':disabled')) {
                  app.flashMessenger('error', 'Please connect to ' + socialNetwork);
                  connectionError = true;
                }
              }
            });

            if (connectionError) {
              return query.reject();
            }

            if (requestData.postingOption == 'single') {
              requestData.postId = _this.getActivePostId();
            }
            requestData.campaignId = _this.getCampaignId();

            if (_.isEmpty(requestData.dateScheduled)) {
              delete requestData.dateScheduled;
            } else {
              if (requestData.dateScheduled != 'now') {
                requestData.dateScheduled = parseInt($(':input[name=dateScheduled]', $form).attr('data-value'));
              }
            }

            if (_.isEmpty(requestData.dateReminder)) {
              delete requestData.dateReminder;
            } else {
              if (requestData.dateReminder != 'now') {
                requestData.dateReminder = parseInt($(':input[name=dateReminder]', $form).attr('data-value'));
              }
            }

            if ($(':input[name=dateReminder]', $form).is(':disabled')) {
              appTransport.post('/api/post/schedule', requestData);
            }

            if ($(':input[name=dateScheduled]', $form).is(':disabled')) {
              requestData.socialNetwork = ['facebook'];
              appTransport.post('/api/post/reminder', requestData);
            }

            return query.promise();
          },
          saveCustomCampaign: function (requestData) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                if (_.isEmpty(response)) {
                  app.flashMessenger('error', 'Empty response');
                  return query.reject(response);
                } else {
                  return query.resolve(response);
                }
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.post('/api/post/campaign-custom', requestData);
            return query.promise();
          },
        }
      };

      _this.enableDisableFavoriteTab = function () {
        if ($favoriteBody.find('[data-row]').length) {
          $('#favorites-tab').attr('data-toggle', 'tab').tooltip('dispose');
          $('#favorites-tab--mobile').attr('data-toggle', 'tab').tooltip('dispose');
        } else {
          $('#favorites-tab').attr('data-toggle', 'tooltip').tooltip();
        }
      };

      /**
       * Mark as favorite
       * @param el
       * @param updateToDb
       */
      _this.markAsFavorite = function (el, updateToDb) {
        if (typeof updateToDb == 'undefined') {
          updateToDb = true;
        }
        var $dataRow = el.closest('[data-row]'),
          dataId = $dataRow.attr('data-row'), $cloneRow, $btnCalendar;

        $dataRow.addClass('post-favorite');
        $dataRow.find('.btn-favorite i').addClass('fas').removeClass('fab');

        $cloneRow = $dataRow.clone();
        $cloneRow.removeClass('post-active hide');
        $cloneRow.find('.trash.action').remove();

        $btnCalendar = $cloneRow.find('.btn-calendar').removeClass('initialized');
        _this.initDateTimePicker($btnCalendar);

        $cloneRow.appendTo($favoriteBody);
        _this.indexPosts($favoriteBody);
        _this.enableDisableFavoriteTab();

        if (updateToDb) {
          _this.updatePost(dataId, {'favorite': true});
          _this.postActions().favorite(dataId);
        }
      };


      /**
       * Unmark as favorite
       * @param el
       * @param updateToDb
       */
      _this.unMarkAsFavorite = function (el, updateToDb) {
        if (typeof updateToDb == 'undefined') {
          updateToDb = true;
        }
        var $dataRow = el.closest('[data-row]'), dataId = $dataRow.attr('data-row');
        $dataRow.removeClass('post-favorite');
        $dataRow.find('.btn-favorite i').addClass('fab').removeClass('fas');
        $favoriteBody.find('[data-row=' + dataId + ']').remove();
        $postBody.find('[data-row=' + dataId + ']').find('i').addClass('fab').removeClass('fas');

        _this.enableDisableFavoriteTab();

        _this.updatePost(dataId, {'favorite': false});
        if (updateToDb) {
          _this.postActions().unfavorite(dataId);
        }
      };


      /**
       * Slide a post
       * @param $row
       * @param $button
       */
      _this.slide = function ($row, $button) {
        var $prev = $('[data-previous]');
        var $next = $('[data-next]');

        $prev.removeAttr('disabled');
        $next.removeAttr('disabled');

        if ($row.prev().length == 0) {
          $prev.attr('disabled', 'disabled');
        }

        if ($row.next().length == 0) {
          $next.attr('disabled', 'disabled');
        }

        if ($row.length == 0) return;

        var $socialPostBody = _this.getActivePostBody();
        var postRow = $socialPostBody[0];
        $socialPostBody = $socialPostBody[1];

        var index = parseInt($row.attr('data-index')),
          $currentSlide = $('.swipe__slide', $socialPostBody).css('opacity', 0),
          currentIndex = parseInt($(_this.getActiveLibraryTab()).find('.post-active').attr('data-index')),
          row = _this.getPost($row.attr('data-row')),
          $postRow = _this.renderPostRow(postRow, row, $socialPostBody),
          $postActionRow = _this.renderPostRow('postRow', row, $postRow, true),
          $animation = index > currentIndex ? 'slideInRight' : 'slideInLeft',
          asc = index > currentIndex;

        _this.initDateTimePicker($postActionRow.find('.btn-calendar'), row.postDate);

        $(_this.getActiveLibraryTab()).find('[data-index]').removeClass('post-active');
        $(_this.getActiveLibraryTab()).find('[data-index=' + index + ']').addClass('post-active');

        $socialPostBody.append($postRow.addClass('animated ' + $animation));
        app.lazyLoadImage($postRow);

        var postsLength = $(_this.getActiveLibraryTab()).find('[data-row]').length;
        $('.post-counter span[data-post-count]', $(context)).text(postsLength);
        $('.post-counter span[data-post-index]', $(context)).text(index + 1);

        var pageNum = $('.page-counter').attr('data-page');

        if ($row.hasClass('hide')) {
          if (asc) {
            if ((index / 10) >= pageNum) {
              $('.table__posts-list--pagination .page-item.next > a').trigger('click');
            }
          } else {
            if ((index / 10) < pageNum) {
              $('.table__posts-list--pagination .page-item.prev > a').trigger('click');
            }
          }
        }
        $currentSlide.remove();

        var $form = $('form[name="scheduler__form"]');
        var dateScheduled = $row.find('.col__date-scheduled').attr('data-date');
        var dataDate = moment(app.localToUtc(moment(dateScheduled))).unix();
        $(':input[name=dateReminder]', $form).val(dateScheduled).attr('data-value', dataDate);
        $(':input[name=dateScheduled]', $form).val(dateScheduled).attr('data-value', dataDate);


        var reminder = $row.attr('data-post-reminder');
        if (reminder && (reminder == false || reminder == 'false')) {
          $('.field__social-network--manual', $form).addClass('d-none');
        } else {
          $('.field__social-network--manual', $form).removeClass('d-none');
        }

      };

      _this.removeSwitchVariable = function (data) {
        if (typeof data != 'undefined') {
          if (typeof data['switch'] != 'undefined') {
            delete data['switch'];
          }

        }
      };

      _this.sanitizePayload = function (data) {
        $.each(data, function (key, value) {
          if ($.isPlainObject(value) || $.isArray(value)) {
            _this.sanitizePayload(value);
          }
          if (value === "" || value === null || $.isEmptyObject(value)) {
            delete data[key];
          }
        });

        return data;
      };

      _this.questionOther = function (questionnaireData, questionId) {
        if (typeof  questionnaireData != 'undefined'
          && typeof  questionnaireData.question != 'undefined'
          && typeof  questionnaireData.question[questionId] != 'undefined') {
          if (typeof questionnaireData.question[questionId].other != 'undefined') {
            questionnaireData.question[questionId] = questionnaireData.question[questionId].other;
          }
        }
        return questionnaireData;
      };

      _this.getFormData = function () {

        var $questionnaireForm = $('form[name="questionnaire__form"]'),
          $socialForm = $('form[name="campaign_social__form"]'),
          $categoryForm = $('form[name="campaign_category__form"]'),
          $subCategoryForm = $('form[name="campaign_sub-category__form"]'),
          questionnaireData = $questionnaireForm.serializeObject(),
          socialData = $socialForm.serializeObject(),
          categoryData = $categoryForm.serializeObject(),
          subCategoryData = $subCategoryForm.serializeObject()
          ;

        questionnaireData = _this.questionOther(questionnaireData, 9);
        questionnaireData = _this.questionOther(questionnaireData, 71);
        questionnaireData = _this.questionOther(questionnaireData, 23);
        questionnaireData = _this.questionOther(questionnaireData, 83);
        questionnaireData = _this.questionOther(questionnaireData, 107);
        questionnaireData = _this.questionOther(questionnaireData, 108);

        var formData = $.extend({}, questionnaireData, categoryData, subCategoryData, socialData);

        if (typeof formData.tag == 'undefined') {
          formData.tag = {"Industries": "All"};
        }

        if (typeof formData.hashtags != 'undefined' && typeof formData.hashtags['keywords'] != 'undefined') {
          var keywords = [];
          _.each(formData.hashtags['keywords'], function (keyword) {
            if (keyword.indexOf('#') < 0) {
              keywords.push('#' + keyword);
            } else {
              keywords.push(keyword);
            }
          });
          formData.hashtags['keywords'] = keywords;
        }


        // Sanitize payload
        if (typeof formData['themes'] != 'undefined') {
          _this.removeSwitchVariable(formData['themes']['holiday']);
          _this.removeSwitchVariable(formData['themes']['season']);
          _this.removeSwitchVariable(formData['themes']['font_scheme']);
          _this.removeSwitchVariable(formData['themes']['color_scheme']);
          _this.removeSwitchVariable(formData['themes']['logo']);
        }

        if (typeof formData['images'] != 'undefined') {
          _this.removeSwitchVariable(formData['images']['color']);
          _this.removeSwitchVariable(formData['images']['people']);
        }

        if (typeof formData['appendText'] != 'undefined') {
          _this.removeSwitchVariable(formData['appendText']);
        }

        delete formData['questionnaire.images'];

        if (typeof formData['question'] != 'undefined' && typeof formData['question']['119'] != 'undefined') {
          formData['question']['119'] = ' ' + $.trim(formData['question']['119']) + ' ';
        }
        return _this.sanitizePayload(formData);
      };


      /**
       * Get Cms Campaign Id
       * @returns {*}
       */
      _this.getCmsCampaignId = function (subCategory) {
        var query = $.Deferred();
        var $campaign = $('input[name="campaign"]', $context);
        var appTransport = app.transport();
        appTransport
          .setEvent('onSuccess', function (response) {
            $campaign.val(response.id);
            return query.resolve(response);
          })
          .setEvent('onError', function (error) {

          })
          .setEvent('onComplete', function () {

          })
        ;
        appTransport.get('/api/campaign/tag/' + subCategory);
        return query.promise();
      };

      _this.setCampaignId = function (subCategory) {
        var template = app.templates['Post__campaign____questions-' + subCategory];

        if (_.indexOf(['120', '121', '122'], subCategory) >= 0) {
          template = app.templates['Post__campaign____questions-' + 119];
        }

        $('.section__information', $context).html(template);
        $('.section__information', $context).removeClass(function (index, css) {
          return (css.match(/(^|\s)section__subcategory--\S+/g) || []).join(' ');
        }).addClass('section__subcategory--' + subCategory);

        if (typeof app.templates['Post__campaign____themes-' + subCategory] == 'undefined') {
          $('.section__themes', $context).hide();
          $('.card-themes', $context).hide();
        } else {
          var themes = $.trim(app.templates['Post__campaign____themes-' + subCategory]);
          if (_.isEmpty(themes) || themes == '') {
            $('.section__themes', $context).hide();
            $('.card-themes', $context).hide();
          } else {
            $('.section__themes', $context).html(themes);
          }
        }

        if (typeof app.templates['Post__campaign____industry-' + subCategory] == 'undefined') {
          $('.section__industry', $context).hide();
          $('.card-industry', $context).hide();
        } else {
          var industry = $.trim(app.templates['Post__campaign____industry-' + subCategory]);
          if (_.isEmpty(industry) || industry == '') {
            $('.section__industry', $context).hide();
            $('.card-industry', $context).hide();
          } else {
            $('.section__industry', $context).html(industry);
          }
        }

        _this.createImageKeywordsTab(subCategory, $('.section__information', $context));

        var imageKeyword;
        if (subCategory == '28') {
          imageKeyword = 'business';
          _this.setDefaultImageKeywords(imageKeyword, imageKeyword, imageKeyword, false);
        } else if (subCategory == '29') {
          imageKeyword = 'beauty';
          _this.setDefaultImageKeywords(imageKeyword, imageKeyword, imageKeyword, false);
        } else if (subCategory == '30') {
          imageKeyword = 'health';
          _this.setDefaultImageKeywords(imageKeyword, imageKeyword, imageKeyword, false);
          imageKeyword = 'wellness';
          _this.setDefaultImageKeywords(imageKeyword, imageKeyword, imageKeyword, false);
        } else if (subCategory == '31') {
          imageKeyword = 'financial freedom';
          _this.setDefaultImageKeywords(imageKeyword, imageKeyword, imageKeyword, false);
        } else if (subCategory == '113') {
          imageKeyword = 'prebuilt opp';
          _this.setDefaultImageKeywords(imageKeyword, imageKeyword, imageKeyword, false);
        } else if (subCategory == '114') {
          imageKeyword = 'prebuilt product';
          _this.setDefaultImageKeywords(imageKeyword, imageKeyword, imageKeyword, false);
        } else if (subCategory == '115') {
          imageKeyword = 'Retail';
          _this.setDefaultImageKeywords(imageKeyword, imageKeyword, imageKeyword, false);
        } else if (_.contains(['134', '138'], subCategory)) {
          imageKeyword = 'All Travel Images';
          _this.setDefaultImageKeywords(imageKeyword, imageKeyword, imageKeyword, false);
        } else if (subCategory == '137') {
          imageKeyword = 'Travel Tips';
          _this.setDefaultImageKeywords(imageKeyword, imageKeyword, imageKeyword, false);
        }

        $('[data-subcategory-name]').text($(':input[name="socialSubCategoryName"]').val());

        _this.getCmsCampaignId(subCategory);

        _this.initDateTimePicker($('.btn-calendar', $('.section__information', $context)), null);
        _this.initDateTimePicker($('.btn-calendar', $('.section__themes', $context)), null);
        _this.createFontsDropDown();
        _this.setHolidaysDropDown();
        _this.setSeasonsDropDown();
        $(context + ' [data-colorpicker]').colorpicker({component: '.input-group-append .input-group-text'});

        $('.section__information', $context).find('[data-image-keyword]').trigger('change');
        _this.validateQuestionnaireInformation();
      };

      _this.setHolidaysDropDown = function () {
        var $dropdown = $('select[name="themes[holiday]"]');
        var dropdowns = app.configObject['holidays'];
        _.each(dropdowns, function (value) {
          $('<option />').val(value).text(value).appendTo($dropdown);
        })
      };

      _this.setSeasonsDropDown = function () {
        var $dropdown = $('select[name="themes[season]"]');
        var dropdowns = app.configObject['seasons'];
        _.each(dropdowns, function (value) {
          $('<option />').val(value).text(value).appendTo($dropdown);
        })
      };

      _this.createImageKeywordsTab = function (subCategory, $context) {
        if (_.indexOf(['133', '134', '135', '136', '138'], subCategory) >= 0) {
          subCategory = 133;
        }

        var template = app.templates['Post__campaign____image-keywords-' + subCategory]
        if (typeof template != 'undefined') {
          template = _.template(template);
          var $template = $(
              template({
                'tags': window['imageKeywords']
              })
            )
            ;
          var $imageKeywordsContainer = $('.image-keywords__hash--container', $context);
          $imageKeywordsContainer.html($template);

          $('.select2-image-keywords', $imageKeywordsContainer).select2({
            theme: "bootstrap4", 'tags': true,
            templateSelection: function (tag, container) {
              var $option = _this.findOptionByValue($('.select2-image-keywords', $imageKeywordsContainer), tag.id);
              if ($option.attr('locked')) {
                $(container).addClass('locked-tag');
                tag.locked = true;
              }
              return tag.text;
            }
          }).on("select2:unselecting", function (e) {
            if ($(e.params.args.data.element).attr('locked')) {
              e.preventDefault();
            }
          }).on("select2:select", function (e) {
            var data = e.params['data'];
            var $select = $(context + ' .section__images .select2-image-keywords');
            var newOption = new Option(data.text, data.id, true, true);
            $select.append(newOption).trigger('change.select2');
            _this.validateQuestionnaireInformation();
          }).on("select2:unselect", function (e) {
            var $select = $(context + ' .section__images .select2-image-keywords');
            var data = e.params['data'];
            var $option = _this.findOptionByValue($select, data.id);
            if ($option.length) {
              $option.remove();
              $select.trigger('change.select2');
            }
            _this.validateQuestionnaireInformation();
          });
        }

      };

      /**
       * @todo :: need to figure out some hardcoded questions for future
       * @param response
       */
      _this.setFormData = function (response) {
        var formData = response.config;

        var $questionnaireForm = $('form[name="questionnaire__form"]'),
          $socialForm = $('form[name="campaign_social__form"]'),
          $categoryForm = $('form[name="campaign_category__form"]'),
          $subCategoryForm = $('form[name="campaign_sub-category__form"]');

        $categoryForm.populate(formData);
        $subCategoryForm.populate(formData);

        _this.setCampaignId(formData.socialSubCategory);

        if (typeof  formData.question['9'] != 'undefined') {
          if (formData.question['9'].indexOf('%') >= 0) {
            var question9Percent = formData.question['9'].split('%')[0];
            formData.question['9'] = {'percent': question9Percent};
            $(':input[name="question[9][percent]"]').removeAttr('readonly').removeAttr('disabled');
          } else {
            var question9Amount = formData.question['9'];
            formData.question['9'] = {'amount': question9Amount};
            $(':input[name="question[9]"][value="amount"]').prop("checked", true);
            $(':input[name="question[9][amount]"]').removeAttr('readonly').removeAttr('disabled');
          }
        }
        formData['question']['119'] = $.trim(formData['question']['119']);

        $questionnaireForm.populate(formData);

        $('[data-campaign-name]', $context).text(_this.pageParams().get()['name']);
        $(':input[name=campaignName]', $context).val(_this.pageParams().get()['name']);
        if (typeof  formData.question['9'] != 'undefined') {
          if (typeof formData.question['9'].percent != 'undefined') {
            $(':input[name="question[9]"][value="percent"]').prop("checked", true);
          } else if (typeof formData.question['9'].amount != 'undefined') {
            $(':input[name="question[9]"][value="amount"]').prop("checked", true);
          }
        }

        if (typeof formData.appendText != 'undefined') {
          $(':input[name="appendText[switch]"]').trigger('click');
        }

        if (typeof formData.question['11'] != 'undefined') {
          if (formData.question['11'] != 'no') {
            $(':input[name="question[11]"][value="yes"]').prop("checked", true);
          }
        }

        if (typeof  formData.question['12'] != 'undefined') {
          if (typeof formData.question['12'].date != 'undefined') {
            $(':input[name="question[12]"][value="yes-end"]').prop("checked", true);
          }
        }

        if (typeof formData.question['30'] != 'undefined') {
          $(':input[name="question[30][switch]"]').trigger('click');
        }

        if (typeof formData.question['91'] != 'undefined') {
          $(':input[name="question[91][switch]"]').trigger('click');
        }

        if (typeof formData.question['98'] != 'undefined') {
          $(':input[name="question[98][switch]"]').trigger('click');
        }

        if (typeof formData.question['73'] != 'undefined') {
          $(':input[name="question[73]"]').trigger('click');
        }

        if (typeof formData.question['121'] != 'undefined') {
          $(':input[name="question[121][switch]"]').trigger('click');
        }

        if (typeof formData.question['71'] != 'undefined') {
          if ($(':input[name="question[71]"] option[value="' + formData.question['71'] + '"]').length == 0) {
            $(':input[name="question[71]"] option[value="' + 'other' + '"]').prop("selected", true).trigger('change');
            setTimeout(function () {
              $(':input[name="question[71][other]"]').val(formData.question['71']);
            }, 1000);
          }
        }

        if (typeof formData.question['23'] != 'undefined') {
          if ($(':input[name="question[23]"] option[value="' + formData.question['23'] + '"]').length == 0) {
            $(':input[name="question[23]"] option[value="' + 'other' + '"]').prop("selected", true).trigger('change');
            setTimeout(function () {
              $(':input[name="question[23][other]"]').val(formData.question['23']);
            }, 1000);
          }
        }

        if (typeof formData.question['83'] != 'undefined') {
          if ($(':input[name="question[83]"] option[value="' + formData.question['83'] + '"]').length == 0) {
            $(':input[name="question[83]"] option[value="' + 'other' + '"]').prop("selected", true).trigger('change');
            setTimeout(function () {
              $(':input[name="question[83][other]"]').val(formData.question['83']);
            }, 1000);
          }
        }

        if (typeof formData.question['107'] != 'undefined') {
          if ($(':input[name="question[107]"] option[value="' + formData.question['107'] + '"]').length == 0) {
            $(':input[name="question[107]"] option[value="' + 'other' + '"]').prop("selected", true).trigger('change');
            setTimeout(function () {
              $(':input[name="question[107][other]"]').val(formData.question['107']);
            }, 1000);
          }
        }


        if (typeof formData.question['108'] != 'undefined') {
          if ($(':input[name="question[108]"] option[value="' + formData.question['108'] + '"]').length == 0) {
            $(':input[name="question[108]"] option[value="' + 'other' + '"]').prop("selected", true).trigger('change');
            setTimeout(function () {
              $(':input[name="question[108][other]"]').val(formData.question['108']);
            }, 1000);
          }
        }

        $(':input[name="question[8]"]').trigger('blur');
        $(':input[name="question[43]"]').trigger('change');

        $('[data-image-keyword]').trigger('blur').trigger('change');


        _this.setThemes = function (formData) {

          if (typeof formData.themes != 'undefined') {

            if (typeof formData.themes['holiday'] != 'undefined') {
              $(':input[name="themes[holiday][switch]"]').trigger('click');
            }

            if (typeof formData.themes['season'] != 'undefined') {
              $(':input[name="themes[season][switch]"]').trigger('click');
            }

            if (typeof formData.themes['color_scheme'] != 'undefined') {
              $(':input[name="themes[color_scheme][switch]"]').trigger('click');
            }

            if (typeof formData.themes['font_scheme'] != 'undefined') {
              $(':input[name="themes[font_scheme][switch]"]').trigger('click');
              $('select[name="themes[font_scheme][font]"]', $context).trigger('change');
            }

            if (typeof formData.themes['logo'] != 'undefined') {
              $(':input[name="themes[logo][switch]"]').trigger('click');
            }
          }
        };

        _this.setIndustry = function (formData) {
          if (typeof formData.tag != 'undefined' && typeof formData.tag['Industries'] != 'undefined'
            && formData.tag['Industries'] != 'All') {
            $(':input[name="tag[Industries][switch]"]').trigger('click');
          }

          if (typeof formData.question != 'undefined' && typeof formData.question['77'] != 'undefined') {
            $(':input[name="question[77]"]').val(formData.question['77']);
          }
        };

        _this.setHashTags = function (formData) {
          if (typeof formData.hashtags != 'undefined' && typeof formData.hashtags['keywords'] != 'undefined') {
            _.each(formData.hashtags['keywords'], function (hashKeyword) {
              _this.setDefaultHashtagKeywords(hashKeyword, hashKeyword, hashKeyword);
            });
            $(':input[name="hashtags[add]"]').trigger('click');
          }
        };

        _this.setVoiceToneStyle = function (formData) {
          if (typeof formData.content != 'undefined' && typeof formData.content['Headline'] != 'undefined') {
            $(':input[name="content[headline][switch]"]').trigger('click');
          }
        };

        _this.setImages = function (formData) {
          if (typeof formData.images['keywords'] != 'undefined') {
            _.each(formData.images['keywords'], function (imageKeyword) {
              _this.setDefaultImageKeywords(imageKeyword, imageKeyword, imageKeyword, false);
            });
          }
          if (typeof formData.images['ids'] != 'undefined') {
            var thumbnails = [];
            var formDataThumbnails = formData.images['thumbnails'].split(',');
            var formDataIds = formData.images['ids'].split(',');

            _.each(formDataIds, function (id, stepIndex) {
              thumbnails.push({
                id: id,
                'pathThumbnail': formDataThumbnails[stepIndex],
                'path': formDataThumbnails[stepIndex]
              })
            });

            _this.setThumbnails({images: thumbnails});

          }

          if (typeof formData.images['color'] != 'undefined' && formData.images['color']['primary'] != 'undefined') {
            $(':input[name="images[color][switch]"]').trigger('click');
          }

          if (typeof formData.images['people'] != 'undefined' && (typeof formData.images['people']['gender'] != 'undefined' || typeof formData.images['people']['behaviour'] != 'undefined')) {
            $(':input[name="images[people][switch]"]').trigger('click');
          }

          $(':input[name="images[option]"]:checked').trigger('click');

        };

        _this.setIndustry(formData);
        _this.setThemes(formData);
        _this.setHashTags(formData);
        _this.setVoiceToneStyle(formData);
        _this.setImages(formData);

      };

      _this.getCampaignId = function () {
        var campaignId = $(":input[name=id]", context).val();
        if (typeof campaignId == 'undefined' || campaignId == '') {
          return false;
        }
        return campaignId;
      };

      _this.getActivePostId = function () {
        return $('.post-active').attr('data-row');
      };

      /**
       * Get a campaign
       * @returns {*}
       */
      window['getCampaign'] = false;
      _this.get = function () {
        if (window['getCampaign'] == true) return;

        window['getCampaign'] = true;
        var query = $.Deferred();
        var campaignId = _this.getCampaignId();
        if (campaignId == false) {
          if (app.getUnsavedCampaign()) {
            _this.warning = app.setWarningAlert('You currently have an unsaved campaign <button class="btn btn-xs btn-info btn-start-unsaved-campaign">click here</button> to continue or start a new campaign below.');
          }
          return query.resolve();
        }

        var appTransport = app.transport();
        appTransport
          .setEvent('onSuccess', function (response) {
            _this.pageParams().resetSession();
            _this.pageParams().set(response);
            if (response.config['custom'] == true) {
              var $categoryForm = $('form[name="campaign_category__form"]');
              $(":input[name=id]", $categoryForm).val(response.id);
              $(':input[name=campaignName]').val(response.name);
              $('[data-campaign-name]').text(response.name);

            } else {
              _this.setFormData(response);
            }

            return query.resolve(response);
          })
          .setEvent('onError', function (error) {
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
          })
          .setEvent('onComplete', function () {
            window['getCampaign'] = false;
          })
        ;
        appTransport.get('/api/post/campaign/' + campaignId);
        return query.promise();
      };

      _this.autosave = function (el) {
        var inputType = el[0].type || el[0].tagName;
        if (
          inputType == 'number' ||
          inputType == 'email' ||
          inputType == 'radio' ||
          inputType == 'checkbox' ||
          inputType == 'select-multiple' ||
          inputType == 'select-one' ||
          inputType == 'text' ||
          inputType == 'textarea' ||
          inputType == 'select'
        ) {
          var requestData = _this.getFormData();
          _this.pageParams().set(requestData);
        }
      };

      _this.initImageEditor = function (dataId, postData) {
        var canvasData, imageId;
        if (_.isNull(postData['imageSettings']) || _.isNull(postData['imageSettings']['settings'])) {

          if (_.isNull(postData.imageSettings)) {
            canvasData = {
              "layout": "basic"
            };
          } else {
            canvasData = {
              "layout": "basic",
              "layer_0": {
                "101": {
                  "type": "image",
                  "background": false,
                  "data": {
                    "images": [
                      {
                        "dimensions": postData.imageSettings['dimensions'],
                        "pathThumbnail": typeof postData.imageSettings['thumbnail'] != 'undefined' ? postData.imageSettings['thumbnail'] :
                          postData.imageSettings['pathThumbnail'],
                        "path": typeof postData.image != 'undefined' ? postData.image : postData.imageSettings['path']
                      }
                    ],
                  }
                }
              }
            };
          }

        } else {
          imageId = postData['imageSettings']['id'];
          var imageSettings = typeof postData.image != 'undefined' ? JSON.parse(postData['imageSettings']['settings']) : postData['imageSettings']['settings'];
          var pluckCanvasData = _.pluck(imageSettings, 'canvasData');
          canvasData = _.filter(pluckCanvasData, function (value) {
            return !_.isEmpty(value) && value != 'undefined' && !_.isNull(value);
          });
          canvasData = canvasData[0];
        }
        var appImageEditor = new app.ImageEditor({
          'canvasData': canvasData,
          'id': imageId,
          'insertCallback': function (response) {
            var updatedImage = response.path;
            var imageId = response.id;
            var postUpdate = _this.postActions().update(dataId, {image: updatedImage});
            $.when(postUpdate).done(function () {
              if (_this.getHash() == 'tab_3') {
                _this.updatePost(dataId, {image: updatedImage});
                $('.swipe__slide').find('.post__image img').src(updatedImage);
              }

              if (_this.getHash() == 'tab_4') {
                appCampaignStep4.getList();
              }
            });
          }
        });

        appImageEditor.show();
      };

      _this.createFontsDropDown = function () {
        _this.loadGoogleFonts();

        var $dropDown = $('select[name="themes[font_scheme][font]"]').next();
        var $toggle = $('.dropdown-toggle', $('.themes__fonts--dropdown'));

        var $button = $('<button class="dropdown-item btn btn-default"></button>').text('--Select --');
        $button.appendTo($dropDown);

        $('select[name="themes[font_scheme][font]"] optgroup', _this.$modal).each(function () {
          var optGroup = $(this).attr('label');
          var fontsDropdown = _.template(templates.fontsDropdown);
          var $fontsDropdown = $(
              fontsDropdown({
                'optGroup': optGroup
              })
            )
            ;

          $fontsDropdown.appendTo($dropDown).find('.card-title').css({'font-family': $(this).attr('data-val')});
          var $collapseBody = $fontsDropdown.find('.card-body');
          $('option', $(this)).each(function () {
            var font = $(this).val().replace(', sans-serif', '').replace(', serif', '').replace("'", '').replace("'", '');
            var $button = $('<button class="dropdown-item btn btn-default"></button>').css({'font-family': font}).text(font).attr('data-font', $(this).val());
            $button.appendTo($collapseBody);
          });

        });
      };

      _this.loadGoogleFonts = function () {
        var fontFamilies = [];

        $('select[name="themes[font_scheme][font]"] optgroup[label!="System"] option', $context).each(function () {
          var font = $(this).val();
          fontFamilies.push(font);
        });

        if (fontFamilies.length) {
          WebFontConfig = {
            google: {families: fontFamilies}
          };


          (function () {
            var wf = document.createElement('script');
            wf.src = ('https:' == document.location.protocol ? 'https' : 'http') +
              '://ajax.googleapis.com/ajax/libs/webfont/1.5.18/webfont.js?' + Date.now();
            wf.type = 'text/javascript';
            wf.async = 'true';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(wf, s);
          })();

        }
      };

      _this.updateCharacterCount = function (count) {
        $(':input[name="facebook-count"]').val(socialCharLimits.facebook - count);
        $(':input[name="linkedIn-count"]').val(socialCharLimits.linkedIn - count);
        $(':input[name="twitter-count"]').val(socialCharLimits.twitter - count);
      };

      return {
        init: function () {

          $.when(_this.get()).done(function () {
            if (_this.getCampaignId()) {
              $context = $(context);
              if (_this.getHash().indexOf('tab_4') >= 0) {

              } else {
                _this.setHash('tab_3');
              }

              _this.campaignLoader.hide();
            }

            $(window).hashchange(function () {
              if (_this.getHash().indexOf('tab_') >= 0) {
                var dataStep = _this.getHash();
                $('.popover').remove();
                switch (dataStep) {
                  case 'tab_1-1' :
                    var socialCategory = $(":input[name=socialCategory]:checked").val();
                    if (typeof socialCategory != 'undefined') {
                      $('.steps__wrapper.step__1-1').removeClass(function (index, css) {
                        return (css.match(/(^|\s)category--\S+/g) || []).join(' ');
                      }).addClass('category--' + socialCategory.replace(/ /g, "_").toLowerCase());
                      _this.socialCategoryChange(socialCategory);
                    }
                    break;
                  case 'tab_3' :
                    if (!$(context).hasClass('custom__campaign--wrapper')) {
                      if (_this.validateQuestionnaireInformation() == false ||
                        _this.validateQuestionnaireSettings() == false) {
                        _this.setHash('tab_2');
                      }
                    }
                    break;
                  case 'tab_2' :
                    var $categoryForm = $('form[name="campaign_category__form"]'),
                      $subCategoryForm = $('form[name="campaign_sub-category__form"]'),
                      categoryData = $categoryForm.serializeObject(),
                      subCategoryData = $subCategoryForm.serializeObject()
                      ;

                    var requestData = $.extend({}, categoryData, subCategoryData);
                    if (_.isUndefined(requestData.socialSubCategory)) {
                      _this.setHash('tab_1');
                    }

                    $('.hashtags__hash', $context).scrollspy({target: "#hashtags__hash"});
                    $('.image-keywords__hash', $context).scrollspy({target: "#image-keywords__hash"});
                }

                _this.navigate(dataStep);
              }
            });

            $(window).off('resize.' + nameSpace).on('resize.' + nameSpace, function () {
              _this.resize();
            });

            if (_this.getHash().indexOf('hash__category') >= 0) {
              _this.setHash('tab_2');
            } else if (_this.getHash().indexOf('tab_') < 0) {
              _this.setHash('tab_0');
            }

            setTimeout(function () {
              $(window).hashchange();
            }, 500);
          });

          /**
           * Trigger Resize event
           */
          _this.resize();

          /**
           * Breadcrumb events
           */
          $(document).off('click.steps--indicators' + nameSpace).on('click.steps--indicators' + nameSpace, context + ' .steps--indicators a, .btn-questionnaire-step-2', function (e) {
            var dataStep = $(this).attr('data-step');
            _this.setHash(dataStep);

            if (dataStep == 'tab_3') {
              $.when(_this.get()).done(function () {
                _this.navigate(dataStep);
              });
            }

          });

          /**
           * Social Media click event
           */
          $(document).off('click.socialMedia__' + nameSpace).on('click.socialMedia__' + nameSpace, context + ' :input[name=socialMedia]', function (e) {
            var campaignId = _this.getCampaignId();
            if (!_.isUndefined(_this.warning)) {
              _this.warning.remove();
            }
            if (campaignId) {
              _this.setHash('tab_1-1');
            } else {
              _this.setHash('tab_1');
            }
          });

          /**
           * Social Category Click Event
           */
          $(document).off('click.SocialCategory__' + nameSpace).on('click.SocialCategory__' + nameSpace, context + ' :input[name=socialCategory]', function (e) {
            if ($(this).val() == 'Business Opportunity') {
              $(":input[name=socialSubCategory]:not(disabled)", $(".field__tag--social_sub_categories--wrapper[data-category='" + $(this).val() + "']")).prop('checked', true).trigger('click');
            } else {
              _this.setHash('tab_1');
              _this.setHash('tab_1-1');
            }
          });

          /**
           * Social Sub Category Click Event
           */
          $(document).off('click.SocialSubCategory__' + nameSpace).on('click.SocialSubCategory__' + nameSpace, context + ' :input[name=socialSubCategory]:not(disabled)', function (e) {
            $(":input[name=socialSubCategoryName]").val($(this).attr('data-text'));
            var subCategory = $(this).val();
            _this.setCampaignId(subCategory);
            _this.setHash('tab_2');
          });

          /**
           * Settings section
           */
          $(document).off('click.section__settings__' + nameSpace).on('click.section__settings__' + nameSpace, context + ' .section__settings :input', function (e) {
            if ($(this).attr('type') == 'radio') {
              if ($(this).closest('.form-group').find('.radio-with-form-control').length) {
                $(this).closest('.form-group').find("input:not([type=radio])").attr('disabled', 'disabled').val('');
                $(this).closest('.form-row').find("input:not([type=radio])").removeAttr('disabled');
              }
            }
            if (_this.validateQuestionnaireSettings()) {
              _this.validateQuestionnaireInformation();
            }
          }).off('blur.section__information__' + nameSpace).on('blur.section__information__' + nameSpace, context + ' .section__settings :input', function (e) {
            var $el = $(this);
            var type = $el[0].type || $el[0].tagName.toLowerCase();
            if (type == 'text' || type == 'number') {
              if (_this.validateQuestionnaireSettings()) {
                _this.validateQuestionnaireInformation();
              }
            }
          });

          /**
           * Information section
           */
          $(document).off('click.section__information__' + nameSpace).on('click.section__information__' + nameSpace, context + ' .section__information :input', function (e) {
            if ($(this).attr('type') == 'radio') {
              if ($(this).closest('.form-group').find('.radio-with-form-control').length) {
                $(this).closest('.form-group').find("input:not([type=radio])").attr('disabled', 'disabled').val('');
                $(this).closest('.form-row').find("input:not([type=radio])").removeAttr('disabled');
              }
            }
            _this.validateQuestionnaireInformation();
          }).off('keyup.section__information__' + nameSpace).on('keyup.section__information__' + nameSpace, context + ' .section__information :input', function (e) {
            var $el = $(this);
            var type = $el[0].type || $el[0].tagName.toLowerCase();
            if (type == 'textarea' || type == 'text' || type == 'number' || type == 'select-one') {
              _this.validateQuestionnaireInformation();
            }

          }).off('blur.section__information__' + nameSpace + ' change.section__information__' + nameSpace)
            .on('blur.section__information__' + nameSpace + ' change.section__information__' + nameSpace, context + ' .section__information :input, .section__industry :input', function (e) {
              var $el = $(this);
              var type = $el[0].type || $el[0].tagName.toLowerCase();
              var name = $el.attr('name');
              var value = $el.val();
              var imageKeyword = $(this).attr('data-image-keyword');

              if (typeof imageKeyword != 'undefined' && !_.isNull(value) && value != '') {
                if (type == 'select-one' && name == 'tag[Industries]') {
                  switch (value) {
                    case 'Health & Wellness - Weight loss' :
                      value = 'Weight loss';
                      break;
                    case 'Health & Wellness - Nutrition' :
                      value = 'Nutrition';
                      break;
                    case 'Beauty - Makeup' :
                      value = 'Makeup';
                      break;
                    case "Fashion - Men's" :
                      value = 'Mens Fashion';
                      break;
                    case "Fashion - Woman's" :
                      value = 'Womans Fashion';
                      break;
                    case "Fashion - Both" :
                      value = 'Fashion';
                      break;
                  }
                  _this.setDefaultImageKeywords(name, value, value, false);
                } else if (type == 'select-one' && name == 'question[23]') {
                  value = 'real estate';
                  _this.setDefaultImageKeywords(name, value, value, false);
                } else if (type == 'select-one' && name == 'question[31]') {
                  value = 'business opportunity';
                  _this.setDefaultImageKeywords(name, value, value, false);
                } else if (type == 'text' && name == 'question[35]') {
                  value = 'nightlife';
                  _this.setDefaultImageKeywords(name, value, value, false);
                } else if (type == 'text' && (name == 'question[40]' || name == 'question[40][product]' || name == 'question[8]' )) {
                  _this.setDefaultImageKeywords(name, value, value, false);
                } else if (type == 'select-one' && name == 'question[100]') {
                  value = 'personal trainer';
                  _this.setDefaultImageKeywords(name, value, value, false);
                } else if (name == 'question[117]' || name == 'question[120]' || name == 'question[121]' || name == 'question[122]') {
                  _this.setDefaultImageKeywords(name, value, value, false);
                } else {
                  _this.setDefaultImageKeywords(name, value, value, true);
                }

                if (type == 'textarea' || type == 'text' || type == 'number' || type == 'select-one') {
                  _this.validateQuestionnaireInformation();
                }
              }
            });

          /**
           * Hashtags section
           */
          $(document).off('click.hashtags__keywords' + nameSpace).on('click.hashtags__keywords' + nameSpace, context + ' .hash__category button', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var value = $(this).text();
            var id = $(this).attr('data-id');
            _this.setDefaultHashtagKeywords(id, value, value);
          });

          /**
           * Image keywords Questionnarie
           */
          $(document).off('click.image-keywords__hash' + nameSpace).on('click.image-keywords__hash' + nameSpace, context + ' .image-keyword__category button', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var value = $(this).text();
            var id = $(this).attr('data-id');
            _this.setDefaultImageKeywords(id, value, value);
            _this.validateQuestionnaireInformation();
          });

          var appImageManagerMulti = new app.ImageManager({
            'imageSelection': 'multiple',
            'insertCallback': function (response) {
              console.log(response);
              _this.setThumbnails(response);
              _this.getImageIds();
            }
          });

          $('.btn-browse-library', $(context)).off('click').on('click', function () {
            appImageManagerMulti.show();
          });


          var $btnLoadMoreImages = $('.btn-load-more-images', $(context));
          var $selectImageByTags = $(context + ' .select2-images-by-tags');

          _this.imageTagActions = function () {
            return {
              getUserTags: function () {
                var query = $.Deferred();
                var appTransport = app.transport();
                appTransport
                  .setEvent('onSuccess', function (response) {
                    return query.resolve(response);
                  })
                  .setEvent('onError', function (error) {
                    app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                  })
                  .setEvent('onComplete', function () {

                  })
                ;
                appTransport.get('/api/user/tag');
                return query.promise();
              },
              getImagesByTag: function (tag) {
                if (tag == '' || tag == 'undefined') return;
                var page = parseInt($btnLoadMoreImages.attr('data-page'));
                var query = $.Deferred();
                var appTransport = app.transport();
                appTransport
                  .setEvent('onSuccess', function (response) {
                    if (parseInt(response.currentPage) < parseInt(response.pages)) {
                      $btnLoadMoreImages.removeClass('d-none');
                      $btnLoadMoreImages.attr('data-page', parseInt(response.currentPage) + 1);
                    } else {
                      $btnLoadMoreImages.addClass('d-none');
                    }
                    _this.setThumbnails({'images': response.result});
                    _this.getImageIds();
                    return query.resolve(response);
                  })
                  .setEvent('onError', function (error) {
                    app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                    return query.reject(error);
                  })
                  .setEvent('onComplete', function () {

                  })
                ;
                appTransport.get('/api/image/shared?page=' + page + '&limitPerPage=20&byTags=' + tag);
                return query.promise();

              }
            }
          };

          $btnLoadMoreImages.off('click.' + nameSpace).on('click.' + nameSpace, function () {
            _this.imageTagActions().getImagesByTag($selectImageByTags.val());
          });

          $.when(_this.imageTagActions().getUserTags()).done(function (response) {

            _.each(response.result, function (row) {
              var $option = $('<option > </option>').appendTo($selectImageByTags);
              $option.text(row.tag);
              $option.val(row.id);
            });

            /**
             * Select 2 with tags
             */
            $selectImageByTags.select2({
              theme: "bootstrap4",
              placeholder: 'Filter by tags',
            }).on("select2:unselect", function (e) {
              var tagId = e.params['data'].id;
              var $imageWrapper = $('.images__thumbnail--wrapper', $context);
              var $items = $imageWrapper.find('.grid-item.tag-' + tagId);
              var select2Tags = $selectImageByTags.val();
              var removableItems = [];

              $items.each(function () {
                var removable = true;
                var $item = $(this);

                var imageTags = $item.attr('data-tags').split(',');
                _.each(select2Tags, function (selectTag) {
                  if (_.contains(imageTags, selectTag)) {
                    removable = false;
                  }
                });


                if (removable == true) {
                  removableItems.push(this);
                }
              });

              if (removableItems.length) {
                _this.imageGrid.masonry('remove', removableItems);
                _this.imageGrid.masonry('layout');
              }

              if ($selectImageByTags.val() == '') {
                $btnLoadMoreImages.attr('data-page', 1);
                $btnLoadMoreImages.addClass('d-none');
              }
            }).on("select2:select", function (e) {
              _this.imageTagActions().getImagesByTag($selectImageByTags.val());
            });
          });

          _this.setThumbnails = function (response) {
            var $imageWrapper = $('.images__thumbnail--wrapper', $context);

            if ($('.grid__wrapper', $imageWrapper).length == 0) {
              var $gridWrapper = $('<div class="grid__wrapper"> </div>').appendTo($imageWrapper);
              var $dataTable = $('<div class="grid" > <div class="grid-sizer"></div> </div>').appendTo($gridWrapper);
              _this.imageGrid = $dataTable.masonry({
                itemSelector: '.grid-item',
                columnWidth: '.grid-sizer',
                percentPosition: true,
              });
            }

            _.each(response.images, function (row) {
              if (!_.isUndefined(row.tags)) {
                row.tagIds = _.pluck(row.tags, 'id').join(',');
                row.tags = _.pluck(row.tags, 'id').map(function (id) {
                  return 'tag-' + id;
                }).join(' ');
              } else {
                row.tags = '';
                row.tagIds = ''
              }

              var imageRow = _.template(templates.imageRow);
              var $imageRow = $(
                imageRow(
                  $.extend(row, {})
                )
              );
              if ($imageWrapper.find('.grid-item[data-row="' + row.id + '"]').length == 0) {
                $imageRow.appendTo($dataTable);
                _this.imageGrid.append($imageRow).masonry('appended', $imageRow);
              }

            });
            app.lazyLoadImage($imageWrapper, function (element) {
              element.parent().find('.image__actions').addClass('show');
              _this.imageGrid.masonry('layout');
            }, function () {
              setTimeout(function () {
                _this.imageGrid.masonry('layout');
              }, 1000);
            });
          };

          _this.getImageIds = function () {
            var $imageIds = $(':input[name="images[ids]"]', $context);
            var $imageThumbs = $(':input[name="images[thumbnails]"]', $context);
            var imageIds = [];
            var imageThumbs = [];

            $('.images__thumbnail--wrapper [data-row]').each(function () {
              var row = $(this);
              var id = row.attr('data-row');
              var thumb = row.find('img').attr('data-thumbnail');
              imageIds.push(id);
              imageThumbs.push(thumb);

            });
            $imageIds.val(imageIds.join(','));
            $imageThumbs.val(imageThumbs.join(','));
            return $imageIds.val();
          };

          /**
           * Questionnaire Submit event
           */
          $(document).off('submit.post__calendar' + nameSpace).on('submit.post__calendar' + nameSpace, context + ' .post-row .btn-calendar', function (e) {
            e.preventDefault();
          });

          /**
           * Post Click Event
           */
          $(document)
            .off('click.post__click' + nameSpace).on('click.post__click' + nameSpace, context + ' [data-post]', function (e) {
              e.preventDefault();
              e.stopPropagation();

              var $row = $(this).closest('[data-row]');
              _this.slide($row);

            }).off('click.previous__' + nameSpace).on('click.previous__' + nameSpace, context + ' [data-previous]', function (e) {
              e.preventDefault();
              e.stopPropagation();

              var $row = $(_this.getActiveLibraryTab()).find('[data-row].post-active').prev();
              _this.slide($row, $(this));
            }).off('click.next__' + nameSpace).on('click.next__' + nameSpace, context + ' [data-next]', function (e) {
              e.preventDefault();
              e.stopPropagation();

              var $row = $(_this.getActiveLibraryTab()).find('[data-row].post-active').next();
              _this.slide($row, $(this));
            });

          /**
           * Data toggle
           */
          $(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
            var currentTarget = e.currentTarget.id;
            var $schedulerSection = $('.scheduler__section', $context);
            switch (currentTarget) {
              case 'allPosts-tab' :
                $postBody.find('.post-active').find('[data-post]').trigger('click');
                break;
                break;

              case 'favorites-tab' :
                $favoriteBody.find('.post-row').eq(0).find('[data-post]').trigger('click');
                break;

              case 'favorites-tab--mobile' :
                $('#favorites-tab').trigger('click');
                $schedulerSection.hide();
                break;

              case 'allPosts-tab--mobile' :
                $('#allPosts-tab').trigger('click');
                $schedulerSection.hide();
                break;

              case 'postingOption-tab--mobile' :
                $schedulerSection.show();
                break;

              case 'preview__facebook-tab':
              case 'preview__linkedIn-tab':
              case 'preview__twitter-tab':
              case 'preview__googlePlus-tab':

                switch (_this.getActivePostPreviewTab().replace('#preview__', '')) {
                  case 'facebook':
                  case 'linkedIn' :
                  case 'twitter':
                  case 'googlePlus':
                    var $row = $(_this.getActiveLibraryTab()).find('[data-row].post-active');
                    _this.slide($row);
                    break;
                }

                break;


            }

          });

          /**
           * Select 2
           */
          $(context + ' .select2').select2({theme: "bootstrap4"});

          _this.initDateTimePicker($('.btn-calendar', $('.questionnaire__accordion')), null);

          /**
           * Select 2 with tags
           */
          $(context + ' .section__images .select2-image-keywords').select2({
            theme: "bootstrap4", 'tags': true,
            templateSelection: function (tag, container) {
              var $option = _this.findOptionByValue($(context + ' .section__images .select2-image-keywords'), tag.id);
              if ($option.attr('locked')) {
                $(container).addClass('locked-tag');
                tag.locked = true;
              }
              return tag.text;
            }
          }).on("select2:unselecting", function (e) {
            if ($(e.params.args.data.element).attr('locked')) {
              e.preventDefault();
            }
          }).on("select2:select", function (e) {
            var $select = $(context + ' .section__information .select2-image-keywords');
            if ($select.length) {
              var data = e.params['data'];
              var newOption = new Option(data.text, data.id, true, true);
              $select.append(newOption).trigger('change.select2');
            }
            _this.validateQuestionnaireInformation();
          }).on("select2:unselect", function (e) {
            var $select = $(context + ' .section__information .select2-image-keywords');
            if ($select.length) {
              var data = e.params['data'];
              var $option = _this.findOptionByValue($select, data.id);
              $option.remove();
              $select.trigger('change.select2');
            }
            _this.validateQuestionnaireInformation();
          });


          /**
           * Select 2 with hashtags
           */
          $(context + ' .select2-hashtags-keywords').select2({
            theme: "bootstrap4", 'tags': true,
            templateSelection: function (tag, container) {
              var $option = $('.select2-hashtags-keywords option[value="' + tag.id + '"]');
              if ($option.attr('locked')) {
                $(container).addClass('locked-tag');
                tag.locked = true;
              }
              if (tag.text.indexOf('#') != 0) {
                tag.text = '#' + tag.text;
              }

              tag.text = tag.text.replace('!', '').replace(/ /g, '');

              return tag.text;
            }
          }).on("select2:unselecting", function (e) {
            if ($(e.params.args.data.element).attr('locked')) {
              e.preventDefault();
            }
          });


          /**
           * Color pickers
           */
          $(context + ' [data-colorpicker]').colorpicker({component: '.input-group-append .input-group-text'});

          /**
           * Custom Switch
           */
          $(document).off('click.switch__' + nameSpace).on('click.switch__' + nameSpace, context + ' :input.custom-switch-input:not(.custom-switch-facebook)', function (e) {
            var $el = $(this),
              name = $(this).attr('name'),
              isChecked = $el.is(":checked"),
              event = $el.closest('.custom-switch__wrapper').find('.event-switch')
              ;

            var checkedVal = 1, unCheckedVal = 0;

            if (typeof $el.attr('data-checked') != 'undefined') {
              checkedVal = $el.attr('data-checked');
            }

            isChecked ? $el.val(checkedVal) : $el.val(unCheckedVal);

            if (event.length) {
              event.removeClass('visible').find(":input").attr('disabled', 'disabled');
              $el.closest('.custom-switch__wrapper').find('.event-switch[data-value=' + $el.val() + ']').addClass('visible')
                .find(":input").removeAttr('disabled');
            }

            switch (name) {
              case "themes[holiday][switch]":
                break;

            }
          });

          /**
           * Change events on selects
           */
          $(document).off('change.switch__' + nameSpace).on('change.switch__' + nameSpace, context + ' :input', function (e) {
            var $el = $(this),
              name = $el.attr('name'),
              val = $el.val()
              ;

            switch (name) {
              case "themes[season]":
              case "themes[holiday]":
                break;


              case 'question[43]':
                if (val == 'Free Trial') {
                  $(':input[name="question[42]"]').closest('.col-auto').removeClass('d-none');
                } else {
                  $(':input[name="question[42]"]').closest('.col-auto').addClass('d-none');
                }
                break;
            }

          });

          /**
           * Radio Events
           */
          $(document).off('click.radio__' + nameSpace).on('click.radio__' + nameSpace, context + ' :input.radio-with-events', function (e) {
            var $el = $(this),
              name = $(this).attr('name'),
              event = $el.closest('.radio-with-events__wrapper').find('.event-radio')
              ;

            if (event.length) {
              event.removeClass('visible');
              $el.closest('.radio-with-events__wrapper').find('.event-radio[data-value=' + $el.val() + ']').addClass('visible');
            }

          });

          /**
           * Dropzone
           */
          $(context + ' [data-dropzone]')
            .dropzone({
              acceptedFiles: 'image/jpg, image/jpeg, image/png, image/gif',
              url: "url for file upload",
              maxFilesize: 10, // MB
              queuecomplete: function () {
                app.flashMessenger('success', 'Files Uploaded Successfully')
              }
            });


          $dateTimePickerModal.datetimepicker(dateTimePickerOptions).on('dp.change', function (e) {
            var $dataModalCalendar = $('[data-modal-calendar]');
            $dataModalCalendar.find(':input[name="dateScheduled"]').val(moment(app.localToUtc(e.date)).unix()).removeAttr('disabled');
            $dataModalCalendar.find(':input[name="dataId"]').val($(e.target).closest('[data-row]').attr('data-row'));
          });


          $(document).off('click.datepicker__modal-campaign' + nameSpace).on('click.datepicker__modal-campaign' + nameSpace, context + ' .step__3 .btn-calendar-modal', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var dataRow = $(this).closest('[data-row]');
            var $modal = $('[data-modal-calendar]');
            $modal.modal('show');

            var id, scheduledDate;
            if (dataRow.length) {
              id = dataRow.attr('data-row');
              scheduledDate = dataRow.find('[data-date]').attr('data-date');
              $modal.attr('data-row', id);
              $modal.removeAttr('data-input-group');
              $modal.removeAttr('data-form');
            } else {
              var inputGroup = $(this).closest('.input-group');
              scheduledDate = inputGroup.find('input').val();

              $modal.removeAttr('data-row');
              $modal.attr('data-input-group', inputGroup.find('input').attr('name'));
              $modal.attr('data-form', inputGroup.closest('form').attr('name'));
            }

            $dateTimePickerModal.data('DateTimePicker').defaultDate(moment(scheduledDate));
          });

          //_this.initDateTimePicker($('.btn-calendar', $('.field__social-network--publish')), null);
          _this.initDateTimePicker($('.btn-calendar-start-date'), null);


          $(document)
            .off('click.scheduler__' + nameSpace).on('click.scheduler__' + nameSpace, context + ' :input[name=postingOption]', function (e) {
              var $el = $(this),
                name = $(this).attr('name'),
                postingOption = $(this).val(),
                $form = $('form[name=scheduler__form]'),
                $fieldSocialNetworkWrapper = $('.field__social-network--wrapper'),
                $fieldSocialNetworkPublishWrapper = $('.field__social-network--publish--wrapper'),
                $fieldSocialNetworkPublishIndividual = $('.field__social-network--publish[data-publish="individual"]'),
                $fieldSocialNetworkPublishCampaign = $('.field__social-network--publish[data-publish="campaign"]'),
                $fieldSocialNetworkReminderIndividual = $('.field__social-network--reminder[data-publish="individual"]'),
                $fieldSocialNetworkReminderCampaign = $('.field__social-network--reminder[data-publish="campaign"]'),
                $socialNetwork = $(':input[name="socialNetwork[]"]:checked', $form)
                ;


              if ($socialNetwork.length) {
                $fieldSocialNetworkPublishWrapper.show().addClass('animated slideInRight')
              } else {
                $fieldSocialNetworkPublishWrapper.hide().removeClass('animated slideInRight')
              }

              $fieldSocialNetworkWrapper.show().addClass('animated slideInRight');

              if (postingOption == 'single') {
                $fieldSocialNetworkPublishIndividual.show().addClass('animated fadeIn');
                $fieldSocialNetworkPublishCampaign.hide().removeClass('animated fadeIn');

                $fieldSocialNetworkReminderIndividual.show().addClass('animated fadeIn');
                $fieldSocialNetworkReminderCampaign.hide().removeClass('animated fadeIn');
              } else {
                $fieldSocialNetworkPublishCampaign.show().addClass('animated fadeIn');
                $fieldSocialNetworkPublishIndividual.hide().removeClass('animated fadeIn');

                $fieldSocialNetworkReminderCampaign.show().addClass('animated fadeIn');
                $fieldSocialNetworkReminderIndividual.hide().removeClass('animated fadeIn');
              }

            }).off('click.field__social-network' + nameSpace).on('click.field__social-network' + nameSpace, context + ' :input[name="socialNetwork[]"]', function (e) {
              var $el = $(this),
                name = $(this).attr('name'),
                value = $(this).val(),
                $form = $('form[name=scheduler__form]'),
                postingOption = $(':input[name=postingOption]:checked').val(),
                $fieldSocialNetworkPublishWrapper = $('.field__social-network--publish--wrapper'),
                $fieldSocialNetworkPages = $('.field__social-network--pages'),
                $fieldSocialNetworkManual = $('.field__social-network--manual'),
                $fieldSocialNetworkPublishIndividual = $('.field__social-network--publish[data-publish="individual"]'),
                $fieldSocialNetworkPublishCampaign = $('.field__social-network--publish[data-publish="campaign"]'),
                $socialNetwork = $(':input[name="socialNetwork[]"]:checked', $form)
                ;


              if ($socialNetwork.length) {
                $fieldSocialNetworkPublishWrapper.show().addClass('animated slideInRight')
              } else {
                $fieldSocialNetworkPublishWrapper.hide().removeClass('animated slideInRight')
              }

              if (value == 'facebook') {
                if ($el.is(":checked") && facebookConnected) {
                  $fieldSocialNetworkPages.show().addClass('animated fadeIn')
                  $fieldSocialNetworkManual.show().addClass('animated fadeIn')
                } else {
                  $fieldSocialNetworkPages.hide().removeClass('animated fadeIn')
                  $fieldSocialNetworkManual.hide().removeClass('animated fadeIn')
                }
              }

              if (postingOption == 'single') {
                $fieldSocialNetworkPublishIndividual.show().addClass('animated fadeIn');
                $fieldSocialNetworkPublishCampaign.hide().removeClass('animated fadeIn');
              } else {
                $fieldSocialNetworkPublishCampaign.show().addClass('animated fadeIn');
                $fieldSocialNetworkPublishIndividual.hide().removeClass('animated fadeIn');
              }

            }).off('change.tag_industries__' + nameSpace).on('change.tag_industries__' + nameSpace, context + ' :input[name="tag[Industries]"]', function (e) {
              var value = $(this).val();
              $('.industry-option-question', $(context)).hide();
              $('.industry-option-question select', $(context)).val('');

              switch (value) {
                case 'Health & Wellness' :
                  $('.health-and-wellness-question', $(context)).show();
                  break;
                case 'Fashion' :
                  $('.fashion-question', $(context)).show();
                  break;
                case 'Beauty' :
                  $('.beauty-question', $(context)).show();
                  break;
              }
            }).off('change.question_71__' + nameSpace).on('change.question_71__' + nameSpace, context + ' :input[name="question[71]"]', function (e) {
              var value = $(this).val();
              var $otherQuestionWrapper = $('.question-71-other', $(context));
              var $otherQuestion = $(':input[name="question[71][other]"]', $(context));
              if (value == 'other') {
                $otherQuestionWrapper.show();
                $otherQuestion.removeAttr('disabled');
              } else {
                $otherQuestionWrapper.hide();
                $otherQuestion.attr('disabled', 'disabled');
              }

            }).off('change.question_23__' + nameSpace).on('change.question_23__' + nameSpace, context + ' :input[name="question[23]"]', function (e) {
              var value = $(this).val();
              var $otherQuestionWrapper = $('.question-23-other', $(context));
              var $otherQuestion = $(':input[name="question[23][other]"]', $(context));
              if (value == 'other') {
                $otherQuestionWrapper.show();
                $otherQuestion.removeAttr('disabled');
              } else {
                $otherQuestionWrapper.hide();
                $otherQuestion.attr('disabled', 'disabled');
              }

            }).off('change.question_83__' + nameSpace).on('change.question_83__' + nameSpace, context + ' :input[name="question[83]"]', function (e) {
              var value = $(this).val();
              var $otherQuestionWrapper = $('.question-83-other', $(context));
              var $otherQuestion = $(':input[name="question[83][other]"]', $(context));
              if (value == 'other') {
                $otherQuestionWrapper.show();
                $otherQuestion.removeAttr('disabled');
              } else {
                $otherQuestionWrapper.hide();
                $otherQuestion.attr('disabled', 'disabled');
              }
            })
            .off('change.data-question-other' + nameSpace).on('change.data-question-other' + nameSpace, context + ' :input[data-question-other]', function (e) {
              var $el = $(this);
              var value = $el.val();
              var $formGroup = $el.closest('.form-group');
              var $otherQuestionWrapper = $('[data-option-other]', $formGroup);
              var $otherQuestion = $(':input', $otherQuestionWrapper);
              if (value == 'other') {
                $otherQuestionWrapper.show().removeClass('d-none');
                $otherQuestion.removeAttr('disabled');
              } else {
                $otherQuestionWrapper.hide().addClass('d-none');
                $otherQuestion.attr('disabled', 'disabled');
              }
            })
            .off('change.data-question-other-inline' + nameSpace).on('change.data-question-other-inline' + nameSpace, context + ' :input[data-question-other-inline]', function (e) {
              var $el = $(this);
              var value = $el.val();
              var $formGroup = $el.closest('.form-group');
              var $otherQuestionWrapper = $('[data-option-other]', $formGroup);
              var $otherQuestion = $(':input', $otherQuestionWrapper);
              if (value == 'other') {
                $otherQuestionWrapper.show().removeClass('d-none');
                $otherQuestion.removeAttr('disabled');
                $otherQuestion.val($otherQuestion.attr('data-other-value'))
                $el.hide();
              } else {
                $otherQuestionWrapper.hide().addClass('d-none');
                $otherQuestion.attr('disabled', 'disabled');
                $el.show();
              }
            })
            .off('click.data-question-other-close' + nameSpace).on('click.data-question-other-close' + nameSpace, context + ' [data-question-other-close]', function (e) {
              var $button = $(this);
              var $formGroup = $button.closest('.form-group');
              var $otherQuestionWrapper = $('[data-option-other]', $formGroup);
              var $question = $('[data-question-other-inline]', $formGroup);
              var $otherQuestion = $(':input', $otherQuestionWrapper);
              $('#' + $button.attr('aria-describedby')).remove();
              $otherQuestionWrapper.hide().addClass('d-none');
              $otherQuestion.attr('disabled', 'disabled');
              $question.show().removeClass('d-none');
              $question.find('option').eq(0).prop('selected', true);
            })

          ;

          $('[data-toggle="popover"]', $context).popover({html: true});

          $('[data-toggle="popover"]', $context).on('shown.bs.popover', function (e) {
            var provider = $(e.currentTarget).attr('data-disconnected');
            var dataConnect = $('.popover-body').find('[data-connect]');
            dataConnect.attr('href', '/api/social/' + provider + '/connect?redirect=my-account/app-campaign/view/' + _this.getCampaignId());
          });


          if (facebookConnected) {
            $.when(_this.postActions().facebook().get()).done(function (response) {

            });
          }


          $(document).off('click.data-action' + socialNameSpace).on('click.data-action' + socialNameSpace, '.field__social-network--wrapper [data-action]', function (e) {
            var action = $(this).attr('data-action'),
              accountId = $(this).attr('data-id'),
              $button = $(this),
              $dataRow = $(this).closest('[data-row]'),
              message = "Remove Page <b>" + $dataRow.find('.col__name').text() + "</b>";

            switch (action) {

              case 'trash':
                $button.button('loading');
                alertify.confirm()
                  .set({
                    labels: {
                      ok: "Delete"
                    }
                  })
                  .set({reverseButtons: true, transition: 'zoom', 'modal': true})
                  .setHeader('Are you sure you want to proceed?')
                  .set('message', message)
                  .set('onok', function (e) {
                    e.cancel = true;
                    $('.ajs-button.ajs-ok').button('loading');
                    $.when(_this.postActions().facebook().delete(accountId)).done(function () {
                      alertify.confirm().close();
                      $('.ajs-button.ajs-ok').button('reset');
                      $('.facebook-account-row[data-row=' + accountId + ']').remove();
                    }).fail(function () {
                      $button.button('reset');
                    });
                  })
                  .set('oncancel', function () {
                    $button.button('reset');
                  })
                  .show();
                break;
            }

          }).off('click.data-disconnect' + socialNameSpace).on('click.data-disconnect' + socialNameSpace, '.field__social-network--wrapper [data-disconnect]', function (e) {
            var $button = $(this),
              provider = $button.attr('data-disconnect'),
              message = "Disconnecting your account will unscheduled any pending post to this " + provider;

            $button.button('loading');
            alertify.confirm()
              .set({
                labels: {
                  ok: "Delete"
                }
              })
              .set({reverseButtons: true, transition: 'zoom', 'modal': true})
              .setHeader('Are you sure you want to proceed?')
              .set('message', message)
              .set('onok', function (e) {
                e.cancel = true;
                $('.ajs-button.ajs-ok').button('loading');
                $.when(_this.postActions().disconnect(provider.toLowerCase())).done(function () {
                  alertify.confirm().close();
                  $('.ajs-button.ajs-ok').button('reset');
                  app.redirect('/my-account/app-user/social-settings', true);
                }).fail(function () {
                  $button.button('reset');
                });
              })
              .set('oncancel', function () {
                $button.button('reset');
              })
              .show();

          });

          $(document).off('submit.scheduler__' + socialNameSpace).on('submit.scheduler__' + socialNameSpace, context + ' form[name=scheduler__form]', function (e) {
            e.preventDefault();

            $.when(_this.postActions().schedule()).done(function () {
              _this.setHash('tab_4');
            }).fail(function () {

            });

          }).off('click.scheduler__' + socialNameSpace).on('click.scheduler__' + socialNameSpace, context + ' [data-scheduler]', function (e) {
            var $form = $('form[name=scheduler__form]');
            e.preventDefault();
            $(':input[name=dateScheduled]', $form).removeAttr('disabled');
            if ($(this).attr('data-scheduler') == 'post-now') {
              $(':input[name=dateScheduled]', $form).val('now');
            }
            $(':input[name=dateReminder]', $form).attr('disabled', 'disabled');
            $form.submit();
          }).off('click.reminder__' + socialNameSpace).on('click.reminder__' + socialNameSpace, context + ' [data-reminder]', function (e) {
            var $form = $('form[name=scheduler__form]');
            e.preventDefault();
            $(':input[name=dateReminder]', $form).removeAttr('disabled');
            $(this).button('loading');
            if ($(this).attr('data-reminder') == 'post-now') {
              $(':input[name=dateReminder]', $form).val('now');
            }
            $(':input[name=dateScheduled]', $form).attr('disabled', 'disabled');
            $form.submit();
          }).off('click.btn-campaign-edit').on('click.btn-campaign-edit', context + ' .step__3 .btn-campaign-edit', function () {
            var $modal = $('[data-modal-campaign-name]');
            $modal.find(':input[name=editCampaignNameStep4]').val($(':input[name=campaignName]').val());
            $modal.modal('show');
          });


          $(document).on('click', function (e) {
            $('[data-toggle="popover"],[data-original-title]').each(function () {
              //the 'is' for buttons that trigger popups
              //the 'has' for icons within a button that triggers a popup
              if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                (($(this).popover('hide').data('bs.popover') || {}).inState || {}).click = false  // fix for BS 3.3.6
              }

            });
          });

          /**
           * Submit Campaign Add form
           * Text Edit Modal
           * Save Text
           * Autosave to localstorage
           * Populate unsaved camapgin
           */
          $(document).off('submit.' + nameSpace).on('submit.' + nameSpace, context + ' form[name="questionnaire__form"]', function (e) {
            e.preventDefault();

            if (_this.validateCampaignName() == false) return;

            var $questionnaireForm = $('form[name="questionnaire__form"]'),
              $submitButton = $('button[type=submit]', $questionnaireForm),
              appTransport = app.transport();

            $('select', $('.section__information', $context)).trigger('change');
            var requestData = _this.getFormData();
            var id = parseInt($.trim(requestData.id));
            delete requestData.id;

            $submitButton.button('loading');
            _this.campaignLoader.show(true);

            appTransport
              .setEvent('onSuccess', function (response) {
                $(":input[name=id]").val(response.id);
                _this.pageParams().reset();
                _this.pageParams().resetSession();
                _this.pageParams().set(response);
                app.redirect('/my-account/app-campaign/view/' + response.id, true);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + '::' + error.message);
                $submitButton.button('reset');
              })
              .setEvent('onComplete', function () {
                $submitButton.button('reset');

              })
            ;

            if (id) {
              appTransport.post('/api/post/build/' + id, requestData);
            } else {
              appTransport.post('/api/post/build', requestData);
            }

            return e.preventDefault();

          }).off('click.editor__post-edit-menu' + nameSpace).on('click.editor__post-edit-menu' + nameSpace, context + '  [data-edit-post-menu]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var postEditMenu = _.template(templates.postEditMenu);
            if (typeof $(this).attr('aria-describedby') == 'undefined') {
              $(this).popover({
                'content': postEditMenu,
                'placement': 'bottom',
                'html': true,
                'offset': "-75, 0"
              });
              $(this).popover('show');
            }

          }).off('click.editor__post-edit-text' + nameSpace).on('click.editor__post-edit-text' + nameSpace, '[data-edit-post-text]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $popOver = $(this).closest('.popover');
            var popOverId = $popOver.attr('id');
            var $popOverButton = $('[aria-describedby="' + popOverId + '"]');
            var $step = $popOverButton.closest('.steps__wrapper');
            var id, text;

            if (_this.getHash() == 'tab_3') {
              var slide = $('[data-edit-post-menu]', $context).parents('.post_preview__section').find('.tab-pane.active').find('.swipe__slide');
              id = slide.find('.post-row').attr('data-row');
              text = slide.find('.col__text').html().trim();
              $('[data-edit-post-menu]').popover('hide');
            }

            if (_this.getHash() == 'tab_4') {
              $('.btn-edit').popover('hide');

              var $dataRow = $popOverButton.closest('[data-row]');
              text = $dataRow.find('.post__text [data-text]').html();
              id = $dataRow.attr('data-row');
            }

            var modal = $('[data-modal-editor]');
            modal.modal('show');

            $('textarea[name=content]').val(text);
            modal.find(':input[name=id]').val(id);
            _this.updateCharacterCount(text.length);

          }).off('click.editor__post-edit-replace-image' + nameSpace).on('click.editor__post-replace-image' + nameSpace, '[data-edit-post-replace-image]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $popOver = $(this).closest('.popover');
            var popOverId = $popOver.attr('id');
            var $popOverButton = $('[aria-describedby="' + popOverId + '"]');
            var $step = $popOverButton.closest('.steps__wrapper');
            var dataId;
            if (_this.getHash() == 'tab_3') {
              $('[data-edit-post-menu]').popover('hide');
              dataId = $('.swipe__slide .post-row', $context).attr('data-row');
            }
            if ($step.attr('data-step') == 'tab_4') {
              $('.btn-edit').popover('hide');
              var $dataRow = $popOverButton.closest('[data-row]');
              dataId = $dataRow.attr('data-row');
            }

            var appImageManager = new app.ImageManager({
              'insertCallback': function (response) {
                var updatedImage = response.images[0].path;
                var imageId = response.images[0].id;
                var postUpdate = _this.postActions().update(dataId, {image: updatedImage});
                $.when(postUpdate).done(function () {
                  if ($step.attr('data-step') == 'tab_3') {
                    _this.updatePost(dataId, {image: updatedImage});
                    $('.swipe__slide').find('.post__image img').src(updatedImage);
                  }
                });
              }
            });
            appImageManager.show();


          }).off('click.data-edit-post-image-remove' + nameSpace).on('click.data-edit-post-image-remove' + nameSpace, '[data-edit-post-image-remove]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $popOver = $(this).closest('.popover');
            var popOverId = $popOver.attr('id');
            var $popOverButton = $('[aria-describedby="' + popOverId + '"]');
            var $step = $popOverButton.closest('.steps__wrapper');
            var dataId;
            if (_this.getHash() == 'tab_3') {
              $('[data-edit-post-menu]').popover('hide');
              dataId = $('.swipe__slide .post-row', $context).attr('data-row');
            }
            if ($step.attr('data-step') == 'tab_4') {
              $('.btn-edit').popover('hide');
              var $dataRow = $popOverButton.closest('[data-row]');
              dataId = $dataRow.attr('data-row');
            }
            var postUpdate = _this.postActions().update(dataId, {image: 'delete'});
            $.when(postUpdate).done(function () {
              if ($step.attr('data-step') == 'tab_3') {

              }
            });


          }).off('click.editor__post-image-edit' + nameSpace).on('click.editor__post-image-edit' + nameSpace, '[data-edit-post-image-edit]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $popOver = $(this).closest('.popover');
            var popOverId = $popOver.attr('id');
            var $popOverButton = $('[aria-describedby="' + popOverId + '"]');
            var $step = $popOverButton.closest('.steps__wrapper');
            var dataId;
            if (_this.getHash() == 'tab_3') {
              $('[data-edit-post-menu]').popover('hide');
              dataId = $('.swipe__slide .post-row', $context).attr('data-row');
              var postData = _this.getPost(dataId);
              _this.initImageEditor(dataId, postData);
            }
            else if ($step.attr('data-step') == 'tab_4') {
              $('.btn-edit').popover('hide');
              var $dataRow = $popOverButton.closest('[data-row]');
              dataId = $dataRow.attr('data-row');
              var dataImageId = $('.post__image img', $dataRow).attr('data-id');

              $.when(_this.postActions().image().get(dataImageId)).done(function (response) {
                _this.initImageEditor(dataId, {
                  'imageSettings': response
                });
              });
            }
          }).off('click.grammar__check' + nameSpace).on('click.grammar__check' + nameSpace, context + ' .btn-spellcheck', function (e) {
            var $button = $(this);
            $(this).addClass('m-progress');
            var modal = $(this).closest('[data-modal-editor]');
            var dataId = modal.find(':input[name=id]').val();
            var text = $('textarea[name=content]').val();
            var postSpellCheck = _this.postActions().spellcheck(dataId, {text: text});
            $.when(postSpellCheck).done(function (response) {
              $button.removeClass('m-progress');
              $('textarea[name=content]').val(response.text);
            });
          }).off('click.emoji__modal' + nameSpace).on('click.emoji__modal' + nameSpace, context + ' .btn-emojis', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var dataRow = $(this).closest('[data-row]');
            var $modal = $('[ data-modal-editor-emojis]');
            $modal.modal('show');

            var id = dataRow.attr('data-row');
            $modal.attr('data-row', id);
          }).off('click.merge-tag-action').off('click.merge-tag-action').on('click.merge-tag-action', '.modal__editor-emojis .modal-body button', function (e) {
            var $editor = $('textarea[name=content]', $('[data-modal-editor]'));
            var text = $editor.val();
            app.insertAtCursor($editor, $(this).text());
            var $modal = $('[ data-modal-editor-emojis]');
            $modal.modal('hide');
          }).off('click.save__text' + nameSpace).on('click.save__text' + nameSpace, context + ' .btn-save-text', function (e) {
            var $button = $(this);
            $(this).addClass('m-progress');
            var modal = $(this).closest('[ data-modal-editor]');
            var dataId = modal.find(':input[name=id]').val();
            var updatedContent = $('textarea[name=content]').val();
            if (typeof dataId == 'undefined' || _.isEmpty(dataId)) {
              var postCreate = _this.postActions().create({
                'app_campaign': _this.getCampaignId(),
                text: updatedContent,
                dateScheduled: $('input[name=customPostScheduledDate]').attr('data-value')
              });
              $.when(postCreate).done(function (response) {
                $button.removeClass('m-progress');
                modal.modal('hide');
              });
            } else {
              var postUpdate = _this.postActions().update(dataId, {text: updatedContent});
              $.when(postUpdate).done(function () {
                $button.removeClass('m-progress');
                modal.modal('hide');
                _this.updatePost(dataId, {text: updatedContent});
                $('.swipe__slide').find('.col__text').html(updatedContent);

              });
            }

          }).off('click.autosave__' + nameSpace).on('click.autosave__' + nameSpace, context + ' :input', function (e) {
            _this.autosave($(this));
          }).off('blur.autosave__' + nameSpace).on('blur.autosave__' + nameSpace, context + ' :input', function (e) {
            _this.autosave($(this));
          }).off('keyup.autosave__' + nameSpace).on('keyup.autosave__' + nameSpace, context + ' :input', function (e) {
            _this.autosave($(this));
          }).off('change.autosave__' + nameSpace).on('change.autosave__' + nameSpace, context + ' :input', function (e) {
            _this.autosave($(this));
          }).off('click.unsaved__campaign' + nameSpace).on('click.unsaved__campaign' + nameSpace, '.btn-start-unsaved-campaign', function (e) {
            _this.warning.remove();
            _this.setFormData({'config': _this.pageParams().get()});
          }).off('change.campaignName__' + nameSpace + ' keyup.campaignName__' + nameSpace)
            .on('change.campaignName__' + nameSpace + ' keyup.campaignName__' + nameSpace, ' form[name="questionnaire__form"] :input[name="campaignName"]', function (e) {
              _this.validateCampaignName();
            });

          $(document).off('click.favorite__postBody__' + nameSpace).on('click.favorite__postBody__' + nameSpace, context + ' .library__section [data-action]', function (e) {
            e.preventDefault();

            var action = $(this).attr('data-action'),
              postId = $(this).attr('data-id'),
              $button = $(this),
              $dataRow = $(this).closest('[data-row]'),
              postData = _this.getPost(postId),
              postText = postData.text,
              postImage = postData.image,
              message = "<div class='post-delete-confirmation'>" +
                '<div class="post__text mb-2">' +
                postText +
                '</div>' +
                '<div class="post__image m-progress">' +
                '<img src="/images/blank.gif" data-src="' + postImage + '" class="lazy img-fluid">' +
                '</div>' +
                '</div>';

            switch (action) {
              case 'favorite' :
                $(this).attr('data-action', 'unfavorite');
                _this.markAsFavorite($(this));

                break;

              case 'unfavorite' :
                $(this).attr('data-action', 'favorite');
                _this.unMarkAsFavorite($(this));
                break;

              case 'trash':
                $button.button('loading');
                alertify.confirm()
                  .set({
                    labels: {
                      ok: "Delete"
                    }
                  })
                  .set({reverseButtons: true, transition: 'zoom', 'modal': true})
                  .setHeader('Confirm Post Delete')
                  .set('message', message)
                  .set('onok', function (e) {
                    e.cancel = true;
                    var $okButton = $('.ajs-button.ajs-ok');
                    $okButton.button('loading');
                    if (typeof postId != 'undefined' && postId != '') {
                      var postDelete = _this.postActions().delete(postId);
                      $.when(postDelete).done(function () {
                        $dataRow.remove();
                        alertify.confirm().close();
                        $okButton.button('reset');
                        $button.button('reset');
                        _this.deletePost(postId);
                        _this.getPosts(_this.getPostData());
                      }).fail(function () {
                        $button.button('reset');
                      });
                    } else {
                      alertify.confirm().close();
                      $okButton.button('reset');
                      $button.button('reset');
                    }
                  })
                  .set('oncancel', function () {
                    $button.button('reset');
                  })
                  .show();
                app.lazyLoadImage($('.ajs-modal'));
                $('.ajs-header').addClass('alertify-scheduled-post-trash');
                $('.ajs-ok').addClass('alertify-scheduled-post-trash');
                break;
            }

          }).off('click.favorite__postPreview__' + nameSpace).on('click.favorite__postPreview__' + nameSpace, '.swipe__wrapper' + ' [data-action]', function (e) {
            e.preventDefault();

            var action = $(this).attr('data-action'),
              $dataRow = $(this).closest('[data-row]'),
              dataId = $dataRow.attr('data-row'),
              $el = $postBody.find('[data-row=' + dataId + ']').find('.btn-favorite');
            switch (action) {

              case 'favorite' :
                $el.attr('data-action', 'unfavorite');
                $(this).attr('data-action', 'unfavorite');
                $dataRow.find('.btn-favorite i').addClass('fas').removeClass('fab');
                _this.markAsFavorite($el);
                break;

              case 'unfavorite' :
                $el.attr('data-action', 'favorite');
                $(this).attr('data-action', 'favorite');
                $dataRow.find('.btn-favorite i').addClass('fab').removeClass('fas');
                _this.unMarkAsFavorite($el);
                break;
            }

          }).off('click.favorite__modal--mobile' + nameSpace).on('click.favorite__modal--mobile' + nameSpace, context + '  #favorites-tab--mobile[data-toggle="tooltip"]', function (e) {
            $('[data-modal-favorite--mobile]').modal('show');
          }).off('click.images__grid' + nameSpace).on('click.images__grid' + nameSpace, '.images__thumbnail--wrapper' + ' [data-action]', function (e) {
            e.preventDefault();

            var action = $(this).attr('data-action'),
              $dataRow = $(this).closest('[data-row]');

            switch (action) {
              case 'delete' :
                $dataRow.remove();
                _this.imageGrid.masonry('layout');
                _this.getImageIds();
                break;

            }

          })
          ;

          $('.collapse', $context).on('shown.bs.collapse', function (e) {
            window.dispatchEvent(new Event('resize'));
          });

          $(document).off('click.collapse' + nameSpace).on('click.collapse' + nameSpace, context + ' button[data-toggle="collapse"]', function (e) {
            e.stopPropagation();
            return e.preventDefault();
          });

          // Themes Font dropdown
          $(document).off('click.themes__fonts--dropdown' + nameSpace).on('click.themes__fonts--dropdown' + nameSpace, '.themes__fonts--dropdown .dropdown-item', function (e) {
            e.preventDefault();
            var font = $(this).attr('data-font');
            var $toggle = $('.dropdown-toggle', $('.themes__fonts--dropdown'));
            if (typeof  font == 'undefined' || font == '' || font == null) {
              $toggle.find('span').css({'font-family': 'inherit'}).text('-- Select --');
              $('select[name="themes[font_scheme][font]"] option[disabled]', $context).prop('selected', true);
            } else {
              $toggle.find('span').css({'font-family': font}).text(font);
              $('select[name="themes[font_scheme][font]"] option[value="' + font + '"]', $context).prop('selected', true);
            }

          });

          $(document).off('change.editor__fonts--select' + nameSpace).on('change.editor__fonts--select' + nameSpace, 'select[name="themes[font_scheme][font]"]', function (e) {
            e.preventDefault();
            var font = $(this).val();
            var $toggle = $('.dropdown-toggle', $('.themes__fonts--dropdown'));
            if (typeof  font == 'undefined' || font == '' || font == null) {
              $toggle.find('span').css({'font-family': 'inherit'}).text('-- Select --');
            } else {
              $toggle.find('span').css({'font-family': font}).text(font);
            }

          });

          // Start from Scratch
          $('#custom-datetime-picker-modal').datetimepicker(dateTimePickerOptions).on('dp.change', function (e) {
            $(e.target).closest('.modal').find('input[name=customPostScheduledDate]').attr('data-value', moment(app.localToUtc(e.date)).unix());
          }).on('dp.show', function (e) {
          });

          $(document).off('click.btn__campaign--scratch' + nameSpace).on('click.btn__campaign--scratch' + nameSpace, context + ' .btn__campaign--scratch', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var dataRow = $(this).closest('[data-row]');
            var $modal = $('[ data-modal-scratch-campaign-name]');
            $modal.modal('show');
          }).off('click.save-campaign' + nameSpace).on('click.save-campaign' + nameSpace, '[data-action="save-campaign"]', function (e) {
            var $button = $(this);
            var $modal = $('[data-modal-scratch-campaign-name]');
            $button.button('loading');
            var campaignName = $modal.find(':input[name=campaignName]').val();
            $.when(_this.postActions().saveCustomCampaign({
              'title': campaignName
            })).done(function (response) {
              $(':input[name=campaignName]').val(campaignName);
              $('[data-campaign-name]').text(campaignName);
              $button.button('reset');
              $modal.modal('hide');
              app.redirect('/my-account/app-campaign/view/' + response.id, true);
            }).fail(function (response) {
              $button.button('reset');
            });
          }).off('click.custom-post' + nameSpace).on('click.custom-post' + nameSpace, context + ' .btn-custom-post', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var dataRow = $(this).closest('[data-row]');
            var $modal = $('[data-modal-custom-post]');
            var currentDate = $('#custom-datetime-picker-modal').data('DateTimePicker').date();
            $modal.find('input[name=customPostScheduledDate]').attr('data-value', moment(app.localToUtc(currentDate)).unix());
            $modal.modal('show');
            $modal = $('[data-modal-editor]');
            $modal.find('input').val('');
          }).off('click.btn-custom-post-step2' + nameSpace).on('click.btn-custom-post-step2' + nameSpace, context + ' .btn-custom-post-step2', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var dataRow = $(this).closest('[data-row]');
            var $modal = $('[data-modal-editor]');
            $modal.find('textarea').val('');
            $modal.modal('show');
            _this.updateCharacterCount(0);
          }).off('keyup.textarea-content' + nameSpace).on('keyup.textarea-content' + nameSpace, context + ' textarea[name="content"]', function (e) {
            var count = $(this).val().length;
            _this.updateCharacterCount(count)
          });


        },

        instance: function () {
          return _this;
        }
      }
    };


  });
})(PreBuilt);

